<template>
<div class="animated fadeIn custom-cases bgV2">
    <div class="d-flex headerOrderDetail">
        <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
            <div class="mt-20 pl-20">
                <h1 class="mb-1">{{CaseCreateObj.case_number}}</h1>
                <template v-if="CaseCreateObj.id && CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_use_nlt_case_module">
                    <p class="caseNextAction" v-if="CaseCreateObj.next_action_and_deadline && CaseCreateObj.next_action_and_deadline[0]">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <span class="ml-2">{{CaseCreateObj.next_action_and_deadline[0].action_name ? CaseCreateObj.next_action_and_deadline[0].action_name : ''  }} - {{CaseCreateObj.next_action_and_deadline[0].deadline ? CaseCreateObj.next_action_and_deadline[0].deadline : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</span>
                    </p>
                </template>
            </div>
            <h4 class="c-orange mb-0" v-if="CaseCreateObj.id">{{Item && Item.status && Item.status != 'New' ? Item.status : ''}}</h4>
        </div>
    </div>
    <b-row>
        <b-col md="12">
            <gofix-tab class="mt-3" :responsive="responsive" :variableWidth="true" :is-reload-tab="true" :data="$route.params.id == '0' ? tabDataNewCase : tabData" @load-tab="loadTab" arrows ref="goFixTab">
                <template slot="gofixTab:right">
                    <template v-if="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_use_nlt_case_module">
                        <template v-if="$route.params.id != 0">
                            <!-- <gofix-button class="mr-3" @click="openEscalation(true)" label="Escalation" outline></gofix-button> -->
                            <!-- <gofix-button v-if="CaseCreateObj.status == 'Final EU Replied' || CaseCreateObj.status == 'EU Replied (FCR)'" class="mr-3" @click="modals.closeCase.open = true" label="CLOSE" outline></gofix-button> -->
                            <gofix-button v-if="CaseCreateObj.status != 'Closed'" class="mr-3" @click="showModalNLTNextAction" label="Next Action" outline></gofix-button>
                        </template>
                        <gofix-button class="ml-3" v-if="$route.params.email_id != 0 && !!$route.params.email_id" label="Cancel" @click="cancelRedirect" :loading="isAction" ></gofix-button>
                        <gofix-button class="ml-3" v-if="isAmendCase" @click="isDisableSave = false" label="AMEND" :disabled="!isDisableSaveOfNLT" outline></gofix-button>
                        <gofix-button class="ml-3" @click="showModalConfirmComplaint" label="SAVE" :loading="isAction" :disabled="isDisableSaveOfNLT"></gofix-button>
                    </template>
                    <template v-else>
                        <gofix-button class="cdf" v-if="$route.params.id == 0 && canSaveRwo && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && !CaseCreateObj.order.length && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="modalMergeCase(1)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'PIC Acknowledged' || CaseCreateObj.status === 'Assigned' || CaseCreateObj.status === 'Cancelled'"></gofix-button>
                        <!--<gofix-button class="abc" v-if="$route.params.id != 0 && canSaveRwo && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && !CaseCreateObj.order.length && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="save(1,true)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'PIC Acknowledged' || CaseCreateObj.status === 'Assigned'"></gofix-button>-->
                        <gofix-button class="abc" v-if="$route.params.id != 0 && checkStatusSetting && CaseCreateObj.status !== 'Closed' && CaseCreateObj.status !== 'Cancelled' && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && !CaseCreateObj.order.length && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="save(1,true)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || !checkStatusSetting || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'" :outline="!canSaveRwo"></gofix-button>
                        <gofix-button class="ml-3" v-if="((CaseCreateObj.fm_staff && CaseCreateObj.fm_staff.user_id == UserLogin.id) || checkInTeam()) && !clickedAcknowledge && CaseCreateObj.status == 'Assigned' && CaseCreateObj.id" @click="clickAcknowledge" label="Acknowledge" outline></gofix-button>
                        <gofix-button class="ml-3" v-if="CaseCreateObj.status == 'PIC Acknowledged' && CaseCreateObj.id" @click="clickOnSite" label="On Site" outline></gofix-button>
                        <gofix-button class="ml-3" v-if="CaseCreateObj.status == 'On Site' && CaseCreateObj.id" @click="clickInProgress" label="In Progress" outline></gofix-button>
                        <gofix-button class="ml-3" v-if="!clickedCompleted && CaseCreateObj.status == 'In Progress' && CaseCreateObj.id" @click="clickComplete" label="Completed" outline></gofix-button>
                        <gofix-button class="ml-3"
                            v-if="((((CaseCreateObj.status == 'On Site') ||
                            (CaseCreateObj.status == 'Completed')) && !checkRoleOnlyHelpDesk()) ||
                            (checkHelpDeskRWOReject() &&
                            CaseCreateObj.status !== 'Closed') &&
                            (!clickedClose && CaseCreateObj.id))"
                            @click="clickClose" label="Close" outline>
                        </gofix-button>
                        <gofix-button class="ml-3"
                            v-if="CaseCreateObj.status != 'Closed' &&
                            CaseCreateObj.status != 'Completed' &&
                            CaseCreateObj.status != 'Cancelled' &&
                            $checkRole($accessModule.case_management_cancel, 'cancel_case') &&
                            (!clickedCancel && CaseCreateObj.id)"
                            @click="clickCancel" label="Cancel" outline>
                        </gofix-button>
                        <gofix-button class="ml-3" v-if="$route.params.id != '0' && (CaseCreateObj.status == 'RWO Issued' && CaseCreateObj.id) && (CaseCreateObj.work_order_id || CaseCreateObj.order.length > 0)" @click="clickRaiseAnotherRWO" label="Raise Another RWO" outline></gofix-button>
                        <gofix-button class="ml-3" v-if="$route.params.email_id != 0 && !!$route.params.email_id" label="Cancel" @click="cancelRedirect" :loading="isAction" ></gofix-button>
                        <gofix-button class="ml-4" v-if="$route.params.id == 0 && (!canSaveRwo || !checkRoleHelpdesk())" label="Save" @click="modalMergeCase" :loading="isAction"></gofix-button>
                        <!-- <gofix-button class="ml-3" v-if="$route.params.id != 0 && (!canSaveRwo || !checkRoleHelpdesk()) && CaseCreateObj.status !== 'Closed'" label="Save" @click="save(1)" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Repeated Feedback'"></gofix-button> -->
                        <gofix-button class="ml-3" v-if="$route.params.id != 0 && (!canSaveRwo || !checkStatusSetting || !checkRoleHelpdesk()) && (Item && Item.status !== 'Closed' && Item.status !== 'Cancelled')" label="Save" @click="save(1)" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || (Item && (Item.status === 'Closed' || Item.status === 'Repeated Feedback' || Item.status === 'Cancelled'))"></gofix-button>
                    </template>
                </template>
                <template slot="gofixTab:basic-info">
                    <b-form>
                        <gofix-card classContent="mt-4 mb-2">
                            <b-row>
                                <b-col md="12">
                                    <b-row>
                                        <b-col md="4">
                                            <gofix-form-dropdown :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Client Contract" :filterable="false" :options="clientContracts" :class="{ 'form-input--error': $v.CaseCreateObj.contract.$error }" v-model="$v.CaseCreateObj.contract.$model" @search="searchContract" @change="changeContract" vLabel="contract_name" required :show-icon-required="true">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="4">
                                            <div class="property-dropdown-container">
                                                <div class="property-dropdown dropdown-custom-tooltip">
                                                    <gofix-form-dropdown :desc="CaseCreateObj.service_location?CaseCreateObj.service_location.root_path:''" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Property Name" :filterable="false" :options="propertiesContracts" :class="[{ 'form-input--error':  $v.CaseCreateObj.service_location.$error }, {'run-loading small-loading': loading.properties} ]" v-model="$v.CaseCreateObj.service_location.$model" @search="searchProperty" @change="changeProperty" vLabel="name" required :show-icon-required="true">
                                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                            <span v-b-tooltip.hover.top :title="option.root_path" v-html="$options.filters.highlightNode(option.root_path, key_search_property || CaseCreateObj.service_location)"></span>
                                                        </template>
                                                    </gofix-form-dropdown>
                                                </div>
                                                <span @click="openModalProperty" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                            </div>
                                        </b-col>
                                        <b-col md="2">
                                            <div class="property-dropdown-container">
                                                <div class="property-dropdown">
                                                    <gofix-form-dropdown
                                                        :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                        vLabel="reference_value_text"
                                                        label="Avenue Of Feedback"
                                                        :options="avenueOfFeedbackOption"
                                                        v-model="avenueOfFeedbackModel"
                                                        class="gofixInputNoMinWidth"
                                                        :required="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_avenue_of_feedback_mandatory"
                                                        :show-icon-required="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_avenue_of_feedback_mandatory">
                                                        <template #gofixInput:dropdown:option="{ reference_value_text, reference_value_abbr }">
                                                            <span :class="{'text-red': reference_value_abbr == 'qp-email-urgent' }"> {{ reference_value_text }}</span>
                                                        </template>
                                                        <template #gofixInput:dropdown:selected-option="{ reference_value_text }">
                                                            <span>{{ reference_value_text }}</span>
                                                        </template>
                                                    </gofix-form-dropdown>
                                                </div>
                                                <span @click="modals.avenueOfFeedback.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                            </div>
                                        </b-col>

                                        <b-col md="2">
                                            <gofix-form-input label="Recorded By" v-model="CaseCreateObj.recorded_by.name" autocomplete="off" disabled>
                                            </gofix-form-input>
                                        </b-col>

                                    </b-row>
                                </b-col>
                                <b-col md="12">
                                    <b-row>
                                        <b-col md="2">
                                            <gofix-form-input-date :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Date Reported" :class="{ 'form-input--error': $v.CaseCreateObj.reported_date.$error }" v-model="$v.CaseCreateObj.reported_date.$model" required showIconRequired>
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="2">
                                            <div class="property-dropdown-container">
                                                <div class="dropdown-custom-tooltip" :class="{ 'property-dropdown': showNowIcon }">
                                                    <gofix-form-input-time ref="timet" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" class="caseSelectTime" label="Time Reported" :class="{ 'form-input--error': $v.CaseCreateObj.reported_time.$error }" v-model="$v.CaseCreateObj.reported_time.$model" required showIconRequired></gofix-form-input-time>
                                                </div>
                                                <span v-if="showNowIcon" @click="getDateTimeNow()" id="icon-time-now" class="property-tree-icon" v-b-tooltip.hover.top title="Now">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V2H16ZM17 13H12V18H17V13ZM5 20H19V9H5V20Z" fill="black" fill-opacity="0.54"/>
                                                    </svg>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col md="2">
                                            <gofix-form-input desc="dd.mm.yyyy" :disabled="true" label="Date Recorded" v-model="dateRecorded" autocomplete="off"></gofix-form-input>
                                        </b-col>

                                        <b-col md="2">
                                            <gofix-form-input :disabled="true" label="Time Recorded" v-model="timeRecorded"></gofix-form-input>
                                        </b-col>

                                        <b-col md="2">
                                            <gofix-form-input-number label="Phone Number" v-model="CaseCreateObj.recorded_by.phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" disabled class="gofixInputNoMinWidth">
                                            </gofix-form-input-number>
                                        </b-col>

                                        <b-col md="2">
                                            <gofix-form-input label="Email" type="email" v-model="CaseCreateObj.recorded_by.email" autocomplete="off" disabled class="gofixInputNoMinWidth inputOverFollow">
                                            </gofix-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <b-row class="card-reduc-margin">
                            <b-col md="6" class="pr-6">
                                <gofix-card class="cardFullHeight" classContent="mb-0" title="Requestor Info">
                                    <b-row>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="6">
                                                    <!-- :reduce="option => option.data_type" -->
                                                    <gofix-form-dropdown
                                                        @change="selectedRequestorType"
                                                        label="Requestor Type"
                                                        :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                        :clearable="true"
                                                        required
                                                        :show-icon-required="true"
                                                        :filterable="false"
                                                        v-model="requestor_type"
                                                        vLabel="title"
                                                        :options="requestorTypeOptions">
                                                    </gofix-form-dropdown>
                                                </b-col>
                                                 <!-- <b-col md="6">
                                                    <gofix-form-dropdown label="Select Requestor" vLabel="first_name" :options="selectRequestors" :append-to-body="true" :class="{ 'form-input--error': $v.CaseCreateObj.addresses.$error }" v-model="$v.CaseCreateObj.addresses.$model" :filterable="false" @search="searchRequestor" @change="selectedRequestor" :disabled="CaseCreateObj.status === 'Closed' || CaseCreateObj.isNewRequestor">
                                                        <template #gofixInput:dropdown:option="{ first_name, last_name, email, primary_phone, secondary_phone }">
                                                            <div class="CaseShowMoreText"> {{ first_name + " " + (last_name ? last_name : '') }}{{email ? (' - ' + email) : ''}}{{ primary_phone ? (' - ' + primary_phone) : (secondary_phone ? (' - ' + secondary_phone) : '')}} </div>
                                                        </template>

                                                        <template #gofixInput:dropdown:selected-option="{ first_name, last_name, email, primary_phone, secondary_phone }">
                                                            <div class="CaseShowMoreText">{{ first_name + " " + (last_name ? last_name : '') }}{{email ? (' - ' + email) : ''}}{{ primary_phone ? (' - ' + primary_phone) : (secondary_phone ? (' - ' + secondary_phone) : '')}}</div>
                                                        </template>
                                                    </gofix-form-dropdown>
                                                </b-col> -->
                                                <!-- <b-col md="3">
                                                    <div>
                                                        <b-form-checkbox :disabled="CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'" v-model="CaseCreateObj.isNewRequestor" @change="resetRequestor" class="new_requestor" id="checkbox">New requestor</b-form-checkbox>
                                                    </div>
                                                </b-col> -->
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row align-v="center">
                                                <b-col md="auto">
                                                    <b-form-radio class="requestor-radio" v-model="CaseCreateObj.isNewRequestor" name="is_new_requestor" :value="false" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT">Search Existing Requestor</b-form-radio>
                                                </b-col>
                                                <b-col>
                                                    <gofix-form-dropdown label="Requestor" vLabel="first_name" :options="selectRequestors" :append-to-body="true" :class="{ 'form-input--error': $v.CaseCreateObj.addresses.$error }" v-model="$v.CaseCreateObj.addresses.$model" :filterable="false" @search="searchRequestor" @change="selectedRequestor" :disabled="isDisableSaveOfNLT || !this.requestor_field || CaseCreateObj.isNewRequestor">
                                                        <template #gofixInput:dropdown:option="{ first_name, last_name, email, primary_phone, secondary_phone }">
                                                            <div class="CaseShowMoreText"> {{ first_name + " " + (last_name ? last_name : '') }}{{email ? (' - ' + email) : ''}}{{ primary_phone ? (' - ' + primary_phone) : (secondary_phone ? (' - ' + secondary_phone) : '')}} </div>
                                                        </template>

                                                        <template #gofixInput:dropdown:selected-option="{ first_name, last_name, email, primary_phone, secondary_phone }">
                                                            <div class="CaseShowMoreText">{{ first_name + " " + (last_name ? last_name : '') }}{{email ? (' - ' + email) : ''}}{{ primary_phone ? (' - ' + primary_phone) : (secondary_phone ? (' - ' + secondary_phone) : '')}}</div>
                                                        </template>
                                                    </gofix-form-dropdown>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12" class="mb-4">
                                            <b-form-radio class="requestor-radio" v-model="CaseCreateObj.isNewRequestor" name="is_new_requestor" :value="true" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT">Add New Requestor</b-form-radio>
                                            <!-- <b-form-checkbox :disabled="CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'" v-model="CaseCreateObj.isNewRequestor" @change="resetRequestor" class="new_requestor" id="checkbox">Add New Requestor</b-form-checkbox> -->
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="3">
                                                    <gofix-form-dropdown
                                                            class="gofixInputNoMinWidth"
                                                            label="Salutation"
                                                            vLabel="reference_value_text"
                                                            :reduce="option => option.reference_value_text"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || (!this.requestor_field && !CaseCreateObj.isNewRequestor)"
                                                            :searchable="false"
                                                            :filterable="false"
                                                            :class="{ 'form-input--error': $v.CaseCreateObj.requestor.salutation.$error }"
                                                            v-model="$v.CaseCreateObj.requestor.salutation.$model"
                                                            :required="CaseCreateObj.isNewRequestor"
                                                            :clearable="false"
                                                            :show-icon-required="true"
                                                            :options="salutationOptions">
                                                    </gofix-form-dropdown>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-form-input label="First Name" autocomplete="off" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" :required="CaseCreateObj.isNewRequestor" :clearable="false" :class="{ 'form-input--error': $v.CaseCreateObj.requestor.first_name.$error }" v-model="$v.CaseCreateObj.requestor.first_name.$model" :show-icon-required="true">
                                                    </gofix-form-input>
                                                </b-col>
                                                <b-col md="5">
                                                    <gofix-form-input label="Last Name" v-model="CaseCreateObj.requestor.last_name" autocomplete="off" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" :clearable="false">
                                                    </gofix-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <!-- <b-col md="6">
                                                    <gofix-form-dropdown
                                                            @change="selectedRequestorTypeTwo"
                                                            label="Requestor Type"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed' || (!this.requestor_field && !CaseCreateObj.isNewRequestor)"
                                                            :clearable="false"
                                                            :show-icon-required="true"
                                                            :filterable="false"
                                                            :required="true" :class="{ 'form-input--error': $v.CaseCreateObj.requestor.requestor_type.$error }"
                                                            v-model="$v.CaseCreateObj.requestor.requestor_type.$model"
                                                            vLabel="reference_value_text"
                                                            :reduce="option => option.reference_value_text"
                                                            :options="requestorTypeOptions">
                                                    </gofix-form-dropdown>
                                                </b-col> -->
                                                <b-col md="6">
                                                    <gofix-form-dropdown
                                                            label="Preferred Mode of Contact"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field"
                                                            :clearable="false"
                                                            :show-icon-required="true"
                                                            :filterable="false"
                                                            :required="true"
                                                            :class="{ 'form-input--error': $v.CaseCreateObj.requestor.preferred_contact_mode.$error }"
                                                            v-model="$v.CaseCreateObj.requestor.preferred_contact_mode.$model"
                                                            class="textNoCapitalize"
                                                            vLabel="reference_value_text"
                                                            :reduce="option => option.reference_value_text"
                                                            :options="preferModeOfContactOptions">
                                                    </gofix-form-dropdown>
                                                </b-col>
                                                <b-col md="6">
                                                    <div class="property-dropdown-container">
                                                        <div class="property-dropdown dropdown-custom-tooltip">
                                                            <gofix-form-input label="Company" type="text" v-model="$v.CaseCreateObj.requestor.company_name.$model" autocomplete="off" :class="['gofixInputNoMinWidth', { 'form-input--error': $v.CaseCreateObj.requestor.company_name.$error }]"
                                                                :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                                :required="((CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_use_nlt_case_module) || (CaseCreateObj.isNewRequestor && (requestor_type && requestor_type.data_type && (requestor_type.data_type !== 'Generic Address' && requestor_type.data_type !== 'Tenant' && requestor_type.data_type !== 'NLT Caller Profile'))))"
                                                                :show-icon-required="true">
                                                            </gofix-form-input>
                                                        </div>
                                                        <span @click="modals.requestorCompany.open = true" class="property-tree-icon">
                                                            <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                                <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                                <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                                            </svg>
                                                        </span>
                                                    </div>

                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <!-- <b-col md="6">
                                                    <gofix-form-dropdown
                                                            v-if="!is_tenant_public_company"
                                                            label="Company"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed' || (!this.requestor_field && !CaseCreateObj.isNewRequestor)"
                                                            :clearable="true" :filterable="false" :class="{ 'form-input--error': $v.CaseCreateObj.requestor.company.$error }"
                                                            v-model="$v.CaseCreateObj.requestor.company.$model" :options="companies" :append-to-body="true"
                                                            @search="loadCompany"
                                                            :required="CaseCreateObj.isNewRequestor && (($v.CaseCreateObj.requestor.requestor_type.$model !== 'Public') && ($v.CaseCreateObj.requestor.requestor_type.$model !== 'Tenant'))"
                                                            :show-icon-required="true" vLabel="name">
                                                    </gofix-form-dropdown>
                                                    <gofix-form-input v-if="is_tenant_public_company" label="Company" type="text" v-model="CaseCreateObj.case_requestor.company_name" autocomplete="off" class="gofixInputNoMinWidth">
                                                    </gofix-form-input>
                                                </b-col> -->
                                                <b-col md="6">
                                                    <gofix-form-input label="Email" type="email" v-model="$v.CaseCreateObj.requestor.email.$model" autocomplete="off" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" :filterable="false" class="gofixInputNoMinWidth">
                                                    </gofix-form-input>
                                                </b-col>
                                                <b-col md="6">
                                                    <gofix-form-input-number label="Phone Number" v-model="CaseCreateObj.requestor.secondary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" class="gofixInputNoMinWidth">
                                                    </gofix-form-input-number>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <!-- <b-col md="6">
                                                    <gofix-form-input-number label="Phone Number" v-model="CaseCreateObj.requestor.secondary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed' || (!this.requestor_field && !CaseCreateObj.isNewRequestor)" class="gofixInputNoMinWidth">
                                                    </gofix-form-input-number>
                                                </b-col> -->
                                                <b-col md="4">
                                                    <gofix-form-input-number label="Mobile Phone" v-model="CaseCreateObj.requestor.primary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" class="gofixInputNoMinWidth">
                                                    </gofix-form-input-number>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-form-input-number label="Call In Number" v-model="CaseCreateObj.requestor.call_in_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" class="gofixInputNoMinWidth">
                                                    </gofix-form-input-number>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-form-input-number label="Alternative Phone Number" v-model="CaseCreateObj.requestor.alternative_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field" class="gofixInputNoMinWidth">
                                                    </gofix-form-input-number>
                                                </b-col>
                                                <b-col md="8">
                                                    <gofix-form-dropdown label="Tags" vLabel="reference_value_text" :clearable="false" v-model="CaseCreateObj.requestor.tags" :options="optionTags.caseRequestor" :multiple="true" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field">
                                                    </gofix-form-dropdown>
                                                </b-col>
                                                <!-- <b-col md="4">
                                                     <span @click="openModalEmail" ><img src="img/on.png" width="30px" v-if="$route.params.email_id != 0 && !!$route.params.email_id" /></span>
                                                </b-col> -->
                                            </b-row>
                                           
                                        </b-col>
                                        <b-col md="12" class="mb-4" v-if="requestor_type && requestor_type.data_type && (requestor_type.data_type != 'Generic Address' && requestor_type.data_type != 'NLT Caller Profile')">
                                            <hr />
                                            <b-row align-v="center">
                                                <b-col  md="auto">
                                                    <div class="d-flex field-display-basic">
                                                        <span class="label mr-0">Link to existing {{ requestor_type && requestor_type.data_type ? requestor_type.data_type : '' }}</span>
                                                    </div>
                                                </b-col>
                                                <b-col>
                                                    <template v-if="requestor_type && requestor_type.data_type && (requestor_type.data_type == 'Company Profile' || requestor_type.data_type == 'Supplier' || requestor_type.data_type == 'Client' || requestor_type.data_type == 'FM Company')">
                                                        <gofix-form-dropdown
                                                            label="Company"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field || !CaseCreateObj.isNewRequestor"
                                                            :clearable="true" :filterable="false"
                                                            v-model="selectedLinkToExisting"
                                                            :options="optionsLinkToExistingToCompany"
                                                            :append-to-body="true"
                                                            @search="loadCompany"
                                                            :show-icon-required="true"
                                                            vLabel="name">
                                                        </gofix-form-dropdown>
                                                    </template>
                                                    <template v-if="requestor_type && requestor_type.data_type && (requestor_type.data_type == 'User Account' || requestor_type.data_type == 'Tenant')">
                                                        <gofix-form-dropdown
                                                            label="FM User"
                                                            vLabel="first_name"
                                                            :options="optionsLinkToExistingToUser"
                                                            :append-to-body="true"
                                                            class="mb-0"
                                                            :filterable="false"
                                                            @search="loadUsers"
                                                            v-model="selectedLinkToExisting"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT || !this.requestor_field || !CaseCreateObj.isNewRequestor">
                                                            <template #gofixInput:dropdown:option="{ name, email }">
                                                                <div class="CaseShowMoreText"> {{ name }}{{email ? (' - ' + email) : ''}}</div>
                                                            </template>

                                                            <template #gofixInput:dropdown:selected-option="{ name, email }">
                                                                <div class="CaseShowMoreText">{{ name }}{{email ? (' - ' + email) : ''}}</div>
                                                            </template>
                                                        </gofix-form-dropdown>
                                                    </template>
                                                </b-col>
                                                <b-col md="3">
                                                    <gofix-button @click="populateToTequestor" label="Populate detail back to requestor info" outline :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed' || !this.requestor_field || !CaseCreateObj.isNewRequestor"></gofix-button>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                            </b-col>
                            <b-col md="6" class="pl-6">
                                <gofix-card class="cardFullHeight" classContent="mb-0" title="Case Info">
                                    <b-row>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="6">
                                                    <gofix-form-properties :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Location of Incident" :property-id="CaseCreateObj.service_location ? CaseCreateObj.service_location.id : null" valueFormat="object"  v-model="CaseCreateObj.case_detail.location" :desc="CaseCreateObj.case_detail.location ? CaseCreateObj.case_detail.location.root_path : ''" :show-icon-required="true" class="gofixInputNoMinWidth text-normal">
                                                    </gofix-form-properties>
                                                </b-col>
                                                <b-col md="6">
                                                    <template v-if="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && !CaseCreateObj.contract.case_settings.is_free_text_for_unit_no">
                                                        <gofix-form-dropdown
                                                            label="Unit No"
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                            :clearable="true"
                                                            v-model="CaseCreateObj.case_detail.unit_no"
                                                            :options="optionsCaseSubLocation"
                                                            :reduce="option => option.sub_location"
                                                            :append-to-body="true"
                                                            vLabel="sub_location">
                                                        </gofix-form-dropdown>
                                                    </template>
                                                    <template v-else>
                                                        <gofix-form-input :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Unit No" type="text" v-model="CaseCreateObj.case_detail.unit_no" autocomplete="off" :show-icon-required="true" :filterable="false" class="gofixInputNoMinWidth">
                                                        </gofix-form-input>
                                                    </template>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="6">
                                                    <div class="property-dropdown-container">
                                                        <div class="property-dropdown dropdown-custom-tooltip">
                                                            <gofix-form-tree :user-value-label-slot="true" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Service Category" :options="treeServiceCategory" :normalizer="normalizerServiceCategory" :load-options="loadOptionServiceCategory" valueFormat="object" :class="{ 'form-input--error': $v.CaseCreateObj.case_detail.service_category.$error }" v-model="$v.CaseCreateObj.case_detail.service_category.$model" :required="true" :show-icon-required="true" class="gofixInputNoMinWidth">
                                                                <template slot="gofixTreeSelect:value-label" slot-scope="{ node }">{{ node.raw.name }}</template>
                                                            </gofix-form-tree>
                                                        </div>
                                                        <span @click="modals.serviceCategory.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                                    </div>
                                                </b-col>
                                                <b-col md="6">
                                                    <div class="label-tag-container">
                                                        <div class="label-tag">
                                                            <div class="label">Equipment</div>
                                                            <div class="tag" v-if="CaseCreateObj.case_detail.equipment">
                                                                <ul>
                                                                    <li v-for="(eq,key) in CaseCreateObj.case_detail.equipment" v-bind:key="key">{{eq.tag_name}}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <span @click="modals.equipment.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                                    </div>
                                                    <!--<gofix-form-dropdown :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed'" label="Equipment" :clearable="false" :filterable="false" v-model="CaseCreateObj.case_detail.equipment" :options="equipment" vLabel="tag_name" :class="[{'run-loading small-loading': loading.equipment}]" :multiple="true" @search="searchEquipment">
                                                    </gofix-form-dropdown>-->
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="8">
                                                    <gofix-form-input-textarea :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="Description" class="caseDescTextArea" :showClassDisabled="false" :classTextarea="(CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT) ? 'no-drop' : ''" v-model="CaseCreateObj.case_detail.feedback_detail" showIconRequired :class="{ 'form-input--error': $v.CaseCreateObj.case_detail.feedback_detail.$error }" required>
                                                    </gofix-form-input-textarea>
                                                </b-col>
                                                <b-col md="4" class="pd-0">
                                                    <div class="mb-3 editPhotoValue width-full">
                                                        <box-photo
                                                            :attachments="CaseCreateObj.attachments"
                                                            :limit-photo="modals.photo.limitPhoto"
                                                            slot-value="before_value"
                                                            class-slot-value="text-right pr-15 mb-15"
                                                            class-btn="pd-0"
                                                            class-list="max-width-per-100"
                                                            :is-slot-after="true"
                                                            :open="modals.photo.open"
                                                            v-model="modals.photo.open"
                                                            :loading="modals.photo.loading"
                                                            :is-reset-data="is_reset"
                                                            :editing="!(CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT)"
                                                            @upload-photo="updateDataPhoto">
                                                        </box-photo>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="12">
                                            <b-row>
                                                <b-col md="4">
                                                    <div class="property-dropdown-container">
                                                        <div class="property-dropdown dropdown-custom-tooltip">
                                                            <gofix-form-tree :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                                :user-value-label-slot="true"
                                                                label="Nature of Feedback"
                                                                :options="treeNatureFeedBack"
                                                                :normalizer="normalizerNatureFeedBack"
                                                                :load-options="loadOptionNatureFeedBack"
                                                                valueFormat="object" :class="{ 'form-input--error': $v.CaseCreateObj.case_detail.nature_feedback.$error }"
                                                                v-model="$v.CaseCreateObj.case_detail.nature_feedback.$model"
                                                                :required="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_nature_of_feedback_mandatory"
                                                                :show-icon-required="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_nature_of_feedback_mandatory"
                                                                class="gofixInputNoMinWidth">
                                                              <template slot="gofixTreeSelect:value-label" slot-scope="{ node }">{{ node.raw.name }}</template>
                                                            </gofix-form-tree>
                                                        </div>
                                                        <span @click="modals.nautureOfFeedback.open = true" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                                    </div>

                                                    <!--<gofix-form-dropdown
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || CaseCreateObj.status === 'Closed'"
                                                            label="Nature of Feedback"
                                                            vLabel="reference_value_text"
                                                            :reduce="option => option.reference_value_text"
                                                            :clearable="false"
                                                            :show-icon-required="true"
                                                            :filterable="false"
                                                            :append-to-body="true"
                                                            required
                                                            :class="{ 'form-input--error': $v.CaseCreateObj.case_detail.nature_of_feedback.$error }"
                                                            v-model="$v.CaseCreateObj.case_detail.nature_of_feedback.$model"
                                                            :options="natureOfFeedbackOptions"
                                                            class="gofixInputNoMinWidth">
                                                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                            <span class="CaseShowMoreText" v-html="option.reference_value_text"></span>
                                                        </template>

                                                    </gofix-form-dropdown>-->

                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-form-dropdown
                                                        :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                        label="Fault Type"
                                                        :filterable="false"
                                                        v-model="CaseCreateObj.case_detail.fault_type"
                                                        :options="selectFaultTypesOptions"
                                                        :append-to-body="true"
                                                        vLabel="fault_name"
                                                        class="gofixInputNoMinWidth"
                                                        @search="searchFaultType">
                                                    </gofix-form-dropdown>
                                                </b-col>
                                                <template v-if="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && !CaseCreateObj.contract.case_settings.is_use_nlt_case_module">
                                                    <b-col md="4">
                                                        <gofix-form-dropdown
                                                            :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                            label="Priority"
                                                            :show-icon-required="true"
                                                            :filterable="true"
                                                            required
                                                            :class="{ 'form-input--error': $v.CaseCreateObj.case_detail.sla.$error }" v-model="CaseCreateObj.case_detail.sla"
                                                            :options="priority"
                                                            :append-to-body="true"
                                                            vLabel="priority"
                                                            class="gofixInputNoMinWidth">
                                                        </gofix-form-dropdown>
                                                    </b-col>
                                                </template>
                                            </b-row>
                                            <b-row>
                                                <b-col md="8">
                                                    <gofix-form-dropdown label="Tags" vLabel="reference_value_text" :clearable="false" v-model="CaseCreateObj.tags" :options="optionTags.caseInfo" :multiple="true" :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT">
                                                    </gofix-form-dropdown>
                                                </b-col>

                                            </b-row>
                                            
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                            </b-col>
                        </b-row>
                        <case-custom-fields ref="caseCustomFields" v-model="CaseCreateObj.custom_fields" :disabled="isDisableSaveOfNLT"></case-custom-fields>
                        <gofix-card title="Case Assignment" class="mb-0" classContent="mb-0">
                            <b-row>
                                <b-col md="6" class="pr-40">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown label="FM Team" vLabel="group_name"
                                                                 :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                                 :options="fm_group_options" :reduce="option => option.id"
                                                                 :append-to-body="true"
                                                                 :required="!CaseCreateObj.fm_staff"
                                                                 :show-icon-required="true"
                                                                 v-model="$v.CaseCreateObj.team_in_charge_id.$model">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                    label="FM Officer In Charge"
                                                    :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                    :required="!CaseCreateObj.team_in_charge_id"
                                                    :show-icon-required="true"
                                                    vLabel="user_name"
                                                    :class="{ 'form-input--error': $v.CaseCreateObj.fm_staff.$error }"
                                                    v-model="$v.CaseCreateObj.fm_staff.$model"
                                                    :options="fm_staff_options"
                                                    :append-to-body="true" @search="loadFmStaff" @change="refreshStatus">
                                                <template #gofixInput:dropdown:option="{ user_name, role_name }">
                                                     {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                                </template>
                                                <template #gofixInput:dropdown:selected-option="{ user_name, role_name }">
                                                    {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                                </template>
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6">
                                    <b-row>
                                        <b-col md="8"  class="pl-40 pr-5">
                                            <gofix-form-supplier
                                                    @supplier="getSupplierLevel1"
                                                    :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT"
                                                    v-if="this.$checkRole(this.$accessModule.order, 'create') || checkRoleHelpdesk()"
                                                    label="Supplier"
                                                    :contract-id="CaseCreateObj.contract ? CaseCreateObj.contract.id:null"
                                                    :service-category-id="CaseCreateObj.case_detail.service_category ? CaseCreateObj.case_detail.service_category.id : null"
                                                    :property-id="CaseCreateObj.case_detail.location ?  CaseCreateObj.case_detail.location.id : null"
                                                    :filterable="false"
                                                    v-model="CaseCreateObj.supplier">
                                            </gofix-form-supplier>
                                        </b-col>
                                        <b-col md="4">
                                            <template v-if="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_use_nlt_case_module">
                                                <div class="text-right">
                                                    <gofix-button class="mr-3" v-if="isAmendCase" @click="isDisableSave = false" label="AMEND" :disabled="!isDisableSaveOfNLT" outline></gofix-button>
                                                    <gofix-button @click="showModalConfirmComplaint" label="SAVE" :loading="isAction" :disabled="isDisableSaveOfNLT"></gofix-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="text-right">
                                                    <gofix-button v-if="$route.params.id === 0 && (!canSaveRwo || !checkRoleHelpdesk())" label="Save" @click="modalMergeCase" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'"></gofix-button>
                                                    <!-- <gofix-button v-if="$route.params.id !== 0 && (!canSaveRwo || !checkRoleHelpdesk()) && CaseCreateObj.status !== 'Closed'" label="Save" @click="save(1)" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed'"></gofix-button> -->
                                                    <gofix-button v-if="$route.params.id !== 0 && (!checkStatusSetting || !checkRoleHelpdesk()) && CaseCreateObj.status !== 'Closed'" label="Save" @click="save(1)" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'"></gofix-button>
                                                    <gofix-button v-if="$route.params.id == 0 && canSaveRwo && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="modalMergeCase(1)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'PIC Acknowledged' || CaseCreateObj.status === 'Assigned' || CaseCreateObj.status === 'Cancelled'"></gofix-button>
                                                    <!--<gofix-button v-if="$route.params.id != 0 && canSaveRwo && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="save(1,true)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'PIC Acknowledged' || CaseCreateObj.status === 'Assigned'"></gofix-button>-->
                                                    <gofix-button v-if="$route.params.id != 0 && checkStatusSetting && CaseCreateObj.status !== 'Closed' && checkRoleHelpdesk() && !CaseCreateObj.work_order_id && $checkRole($accessModule.order, 'create') && $checkRole($accessModule.case_management, 'create')" @click="save(1,true)" label="SAVE & RAISE RWO" :loading="isAction" :disabled="$disabledCreateOrUpdate(this.CaseCreateObj, $accessModule.case_management) || !checkStatusSetting || CaseCreateObj.status === 'Closed' || CaseCreateObj.status === 'Cancelled'" :outline="!canSaveRwo" :marginTopFive="!canSaveRwo"></gofix-button>
                                                </div>
                                            </template>
                                        </b-col>
                                        </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </b-form>
                </template>
                <template slot="gofixTab:work-folder">
                    <WorkFolder></WorkFolder>
                </template>
                <template slot="gofixTab:activity-log">
                    <template v-if="CaseCreateObj.contract && CaseCreateObj.contract.case_settings && CaseCreateObj.contract.case_settings.is_use_nlt_case_module">
                        <case-activities ref="pvActivities" activityType="Case" :activityId="$route.params.id" isCaseActivity :disableImport="true" @loadCase="getCaseEdit"></case-activities>
                    </template>
                    <template v-else>
                        <global-activities ref="globalActivities" activityType="Case" :activityId="$route.params.id" isCaseActivity :disableImport="true"></global-activities>
                    </template>
                </template>
                <template slot="gofixTab:case-reporting">
                    <CaseReporting></CaseReporting>
                </template>
                <template slot="gofixTab:repeated-feedback">
                    <CaseRepeatedFeedback @update-total="total => repeatedFeedbackTotal = total"></CaseRepeatedFeedback>
                </template>
                <template slot="gofixTab:after-title:repeated-feedback" v-if="Item && Item.repeated_feedback">
                    <p class="navbar-title-after">&nbsp;({{Item.repeated_feedback.length}})</p>
                </template>
                <template slot="gofixTab:case-kpi">
                    <CaseKPI />
                </template>
            </gofix-tab>
        </b-col>
    </b-row>
    <b-modal :no-close-on-backdrop="true" id="modal-select-invoice" title="Recent Cases with similar feedback" hide-footer :centered="true" ref="modal-merge-case" @hide="hideModalMergeCase">
        <b-row class="content">
            <b-col md="12">
                <div class="scollingTable similarModal">
                    <gofix-table :settings="tableConfig" :table-items="tableItems" @load-items="getTableData" ref="gofixTable">
                        <template slot="gofix_table:link" slot-scope="row">
                            <gofix-button label="Link" @click="save(row.item)" :loading="isAction" outline></gofix-button>
                        </template>
                        <template slot="gofix_table:location.root_path" slot-scope="row">
                            {{row.item.location && row.item.location.root_path}}
                        </template>
                        <template slot="gofix_table:service_categories.name" slot-scope="row">
                            {{row.item.service_categories.name}}
                        </template>
                        <template slot="gofix_table:reported_time" slot-scope="row">
                            {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:unit_no" slot-scope="row">
                            {{row.item.unit_no}}
                        </template>
                    </gofix-table>
                </div>

                <b-button-group class="d-block text-right">
                    <gofix-button v-if="!checkIsCreateWO" :label="!CaseCreateObj.id ? 'RAISE NEW CASE' : 'SAVE'" @click="raiseNewCase(1)" noBorder></gofix-button>
                    <gofix-button v-if="checkIsCreateWO" :label="!CaseCreateObj.id ? 'RAISE NEW CASE' : 'SAVE & RAISE RWO'" @click="raiseNewCase(1,true)" noBorder></gofix-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-select-invoice" title="Recent Cases of the same property" hide-footer :centered="true" ref="cases-similar-nlt" @hide="hideModalMergeCase">
        <b-row class="content">
            <b-col md="12">
                <div class="scollingTable similarModal">
                    <gofix-table :settings="tableConfigNLT" :table-items="tableItems" @load-items="getTableDataNLT" ref="gofixTable">
                        <template slot="gofix_table:location.root_path" slot-scope="row">
                            {{row.item.location && row.item.location.root_path}}
                        </template>
                        <template slot="gofix_table:case_number" slot-scope="row">
                            <span class="checklistLink" @click="gotoDetail(row.item)"> {{row.item.case_number}} </span>
                        </template>
                        <template slot="gofix_table:service_categories.name" slot-scope="row">
                            {{row.item.service_categories.name}}
                        </template>
                        <template slot="gofix_table:reported_time" slot-scope="row">
                            {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:unit_no" slot-scope="row">
                            {{row.item.unit_no}}
                        </template>
                    </gofix-table>
                </div>
                <b-button-group class="d-block text-right">
                    <gofix-button label="RAISE NEW CASE" @click="raiseNewCaseNLT(1,false)" noBorder></gofix-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-property-tree" title="Search Property" hide-footer :centered="true" v-model="modals.properties.open" ref="modal-SearchProperty">
        <b-form>
            <b-form-group label="" class="mt-0">
                <gofix-form-input class="p-color" label="Property" v-model="modals.properties.root_path" disabled required></gofix-form-input>
                <!--<gofix-form-properties label="Property" :contract-id="CaseCreateObj.contract ? CaseCreateObj.contract.id : null" valueFormat="object" required :show-icon-required="true" :class="{ 'form-input--error': $v.CaseCreateObj.service_location.$error }" v-model="propertiesTree" class="gofixInputNoMinWidth">
                </gofix-form-properties>-->
            </b-form-group>
            <div class="tree-scrollbar">
                <div class="contenAbsolute">
                    <div class="tree-view-properties">
                        <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                            <div slot-scope="{ node }" class="node-container"> {{ node.data.name }} </div>
                        </tree>
                    </div>
                </div>
            </div>
        </b-form>
        <b-button-group class="d-block text-right p-1rem">
            <gofix-button :disabled="CaseCreateObj.status === 'Cancelled' || isDisableSaveOfNLT" label="APPLY" @click="applyProperty" :loading="modals.properties.loading" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" :title="'Cancel Case #' + CaseCreateObj.case_number" hide-footer hide-header :centered="true" v-model="modals.warning.open">
            <div class="center">
               There is an WO associated with Case! <br/>You need to handle the WO separately.<br/>Do you want to proceed?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.warning.open = false">No</b-button>
                <b-button class="custom-btn" @click="openReasonCancelCase" :disabled="modals.warning.loading">
                    <b-spinner v-if="modals.warning.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
    </b-modal>
    <b-modal
        :no-close-on-backdrop="true"
        id="modal-Create"
        size="lg"
        :title="'Cancel Case #' + CaseCreateObj.case_number"
        hide-footer
        :centered="true"
        v-model="modals.cancel.open">
        <b-row>
            <b-col>
                <b-form class="formV2" v-bind:class="{'run-loading':modals.cancel.loading}">
                    <gofix-form-input-textarea
                        label="Reason for Cancellation"
                        class="h-100"
                        required
                        v-model="modals.cancel.data.reason">
                    </gofix-form-input-textarea>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="updateCaseCancellation" :loading="modals.cancel.loading" noBorder></gofix-button>
                    </b-button-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
  <!-- <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.escalation.title" hide-footer :centered="true" v-model="modals.escalation.open">
    <div v-bind:class="{'run-loading small-loading':modals.escalation.loading_content}">
      <b-form class="">
        <b-row>
          <b-col md="12">
            <gofix-form-input label="To" v-model="modals.escalation.data.to" required></gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-input label="CC" v-model="modals.escalation.data.cc"></gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-input label="Subject" v-model="modals.escalation.data.subject"></gofix-form-input>
          </b-col>
          <b-col md="12">
            <editor
                api-key="il3ub5ilogli9992n1eqrbnx9cond36i0lhx8n8i4xj9v1bo"
                :init="editorInit"
                v-model="modals.escalation.data.body"
            />

          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right" >
      <gofix-button label="SEND" :loading="modals.escalation.loading" noBorder @click="sendMail"></gofix-button>
    </b-button-group>
    </div>
  </b-modal> -->
    <b-modal :no-close-on-backdrop="true" id="modal-Create" size="lg" title="Actions" hide-footer :centered="true" @show="orderNextStatus = null" ref="modal-approval-log" v-model="modals.nltNextAction.open">
        <b-row>
            <b-col>
                <b-form class="formV2">
                    <gofix-form-dropdown
                        label="Next Available Actions"
                        vLabel="label"
                        v-model="modals.nltNextAction.data.status"
                        required
                        :options="nltStatus" />
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" :loading="modals.nltNextAction.loading" @click="changeNltStatus" noBorder />
                    </b-button-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>

    <!--  -->
     <!-- <b-modal :no-close-on-backdrop="false" id="modal-ViewEmail" scrollable  :title="modals.viewemail.title" hide-footer :centered="true" v-model="modals.viewemail.open" @hidden="hiddenModalRemark" size='lg'>
            <b-form class="formInvoice pb-11">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="TO" v-model="modals.viewemail.data.to" ></gofix-form-input>
                        <gofix-form-input label="CC" v-model="modals.viewemail.data.cc" ></gofix-form-input>
                        <gofix-form-input label="Subject" v-model="modals.viewemail.data.subject"></gofix-form-input>
                        <iframe id="iframe_new" ref="iframe_new" :src="modals.iframe.src" width="100%" height="70%" scrolling="auto"> </iframe>
                        
                        
                        

                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            
                            <ul class="list-thumb" v-if="modals.viewemail.data.files !== null" style="margin-left:100px!important;" >
                                  
                                

                                <li  v-for="(item,key) in modals.viewemail.data.files" v-bind:key="key" @click="previewFile(item)">  {{item.image_file_name}}  </li>
                            </ul>
                        </b-form-group>

                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
               
            </b-button-group>

           
        </b-modal> -->
   
    <Escalation v-model="modals.escalation.open"  :nltAction="modals.nltNextAction.data.status" :email="this.modals.email" @updateSuccess="loadDataWhenNextActionSuccess"/>
    <ModalNatureOfFeedback :valDropdown="CaseCreateObj.case_detail.nature_feedback" :contract_id="CaseCreateObj.contract && CaseCreateObj.contract.id ? Number(CaseCreateObj.contract.id) : null" :natureSelected="CaseCreateObj.case_detail.nature_feedback ? CaseCreateObj.case_detail.nature_feedback : {}" v-model="modals.nautureOfFeedback.open" @updateData="updateNature" :disabled="isDisableSaveOfNLT"/>
    <ModalRequestorCompany :contract_id="CaseCreateObj.contract && CaseCreateObj.contract.id ? Number(CaseCreateObj.contract.id) : null" v-model="modals.requestorCompany.open" @updateData="updateRequestorCompany" :disabled="isDisableSaveOfNLT"/>
    <ModalServiceCategory :contract_id="CaseCreateObj.contract && CaseCreateObj.contract.id ? Number(CaseCreateObj.contract.id) : null" :serviceSelected="CaseCreateObj.case_detail.service_category ? CaseCreateObj.case_detail.service_category : {}" v-model="modals.serviceCategory.open" @updateData="updateServiceCategory" :disabled="isDisableSaveOfNLT"/>
    <ModalAvenueOfFeedback :options="avenueOfFeedbackOption" :valueSelected="avenueOfFeedbackModel" v-model="modals.avenueOfFeedback.open" @updateData="updateAvenueOfFeedback" :disabled="isDisableSaveOfNLT"/>
    <ModalEquipment :data="CaseCreateObj" v-model="modals.equipment.open" @updateData="updateEquipment"/>

    <div class="fixedCustomPopupBox" v-show="modals.customEmailPopup.active"  :class="[{'active':modals.customEmailPopup.active},{'minimize':modals.customEmailPopup.minimize}]">     
        <b-row class="titleRow">
            <b-col cols="6" class="titleDiv">
                <span class="mt-8 ml-2 titleSpan">Email</span>
            </b-col>
            <b-col cols="6">
                <b-button-group class="d-block text-right mt-5 mb-5">
                    <b-button type="button" variant="outline-dark" size="sm" class="mr-2" v-if="!modals.customEmailPopup.minimize" @click="modals.customEmailPopup.minimize=true;" title="Minimize"><i class="icon-arrow-down"></i></b-button>
                    <b-button type="button" variant="outline-dark" size="sm" class="mr-2" v-if="modals.customEmailPopup.minimize" @click="modals.customEmailPopup.minimize=false;" title="Maximize"><i class="icon-arrow-up"></i></b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-form class="formEmail" id="viewEmailForm" v-bind:class="{'run-loading small-loading':modals.viewemail.loading}">
                <b-row>
                    <b-col md="12">
                            <gofix-text-field label="" class="mt-5 mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Date</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.date"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >From</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.from_name_address"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >To</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.to"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >CC</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.cc"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Subject</span>
                                </div>
                                <div class="textValue">
                                    <span>{{modals.viewemail.data.subject}}</span>
                                </div>
                            </gofix-text-field>
                        <iframe id="iframeNew" ref="iframeNew" :src="modals.viewemail.iframe.src"  width="100%" height="100%" scrolling="auto" @load="iframeNewLoaded"></iframe>
                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            <b-row>
                                <b-col class="col-6 mb-3" v-for="(attachment,index) in  modals.viewemail.data.files" :key="index">
                                        <div class="attachmentInfo">
                                            <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                            <div class="name" @click="previewFile(attachment)">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                        </div>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
    </div>
    <!-- <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" dialog-class="max-width-621" content-class="text-left" v-model="modals.warningTagsNLT.open">
            <div class="py-3 px-4">
                <h5 class="mb-3">Is this a Complaint as per SOP?</h5>
                <b-form-group class="mb-0 pl-3">
                    <b-form-radio class="requestor-radio" v-model="modals.warningTagsNLT.isComplaint" name="is-complaint" value="1">Yes</b-form-radio>
                    <b-form-radio-group
                        id="radio-group-complaint-yes"
                        class="requestor-radio pl-3 py-2"
                        v-model="modals.warningTagsNLT.valueYes"
                        :options="[
                            { text: 'Normal', value: 'Normal', disabled: modals.warningTagsNLT.isComplaint != 1  },
                            { text: 'Urgent (Authorities/Senior Management/Walk in, Social Media)', value: 'Urgent', disabled: modals.warningTagsNLT.isComplaint != 1 },
                            { text: 'Immediate (Litigation, Contactor late/no show)', value: 'Immediate', disabled: modals.warningTagsNLT.isComplaint != 1 }
                        ]"
                        name="complaint-yes-options"
                        stacked
                    ></b-form-radio-group>
                    <b-form-radio class="requestor-radio" v-model="modals.warningTagsNLT.isComplaint" name="is-complaint" value="2">No - General Enquiry, Feedback, Service Request</b-form-radio>
                    <b-form-radio-group
                        id="radio-group-complaint-no"
                        class="requestor-radio pl-3 pt-2"
                        v-model="modals.warningTagsNLT.valueNo"
                        :options="[
                            { text: 'Normal', value: 'Normal', disabled: modals.warningTagsNLT.isComplaint != 2  },
                            { text: 'Urgent', value: 'Urgent', disabled: modals.warningTagsNLT.isComplaint != 2 },
                            { text: 'Immediate', value: 'Immediate', disabled: modals.warningTagsNLT.isComplaint != 2 }
                        ]"
                        name="complaint-no-options"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="submitComplaint">SUBMIT</b-button>
            </b-button-group>
    </b-modal> -->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" dialog-class="max-width-320" content-class="text-left" v-model="modals.warningTagsNLT.open">
        <div class="py-3 px-4">
            <h5 class="mb-3">Is this a Complaint as per SOP?</h5>
            <b-form-group class="mb-0 pl-3">
                <b-form-radio class="requestor-radio mb-2" v-model="modals.warningTagsNLT.isComplaint" name="is-complaint" value="1">Yes</b-form-radio>
                <b-form-radio class="requestor-radio" v-model="modals.warningTagsNLT.isComplaint" name="is-complaint" value="2">No</b-form-radio>
            </b-form-group>
        </div>
        <b-button-group class="btn-group">
            <b-button class="custom-btn" :disabled="modals.warningTagsNLT.loading" @click="submitCase">SUBMIT</b-button>
        </b-button-group>
    </b-modal>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import {
    filters
} from '@/_filterVar.js'
import {
    validationMixin
} from 'vuelidate'
import {
    required,
    requiredIf
} from 'vuelidate/lib/validators'
const ViewerImage = () => import('../plugins/ViewerImage.vue')
const BoxPhoto = () => import('@/views/plugins/BoxPhoto.vue')
const caseActivities = () => import("./ActivityLogs")
const WorkFolder = () => import("./WorkFolder")
const CaseReporting = () => import("./CaseReporting")
const CaseRepeatedFeedback = () => import("./CaseRepeatedFeedback")
const CaseCustomFields = () => import("./CaseCustomFields")
const CaseKPI = () => import("./CaseKPI")
const Escalation = () => import("./Escalation")
import LiquorTree from 'liquor-tree';
const globalActivities = () => import("../global/Activities")
const ModalNatureOfFeedback = () => import("./ModalNatureOfFeedback")
const ModalRequestorCompany = () => import("./ModalRequestorCompany")
const ModalServiceCategory = () => import("./ModalServiceCategory")
const ModalAvenueOfFeedback = () => import("./ModalAvenueOfFeedback")
const ModalEquipment = () => import("./ModalEquipment")

const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};
import moment from 'moment';
// import Editor from '@tinymce/tinymce-vue';

export default {
    name: 'case-detail',
    components: {
        WorkFolder,
        CaseReporting,
        CaseRepeatedFeedback,
        caseActivities,
        ViewerImage,
        BoxPhoto,
        [LiquorTree.name]: LiquorTree,
        CaseCustomFields,
    //   'editor': Editor,
      CaseKPI,
      Escalation,
      globalActivities,
      ModalNatureOfFeedback,
      ModalRequestorCompany,
      ModalServiceCategory,
      ModalAvenueOfFeedback,
      ModalEquipment
    },
    data() {

        return {
            tabData: [{
                    key: "basic-info",
                    title: "Basic Info",
                    active: true
                },
                {
                    key: "work-folder",
                    title: "Work Folder",
                    active: false
                },
                {
                    key: "activity-log",
                    title: "Activity log",
                    active: false
                },
                {
                    key: "case-reporting",
                    title: "Case Reporting",
                    active: false
                }
            ],
            tabDataNewCase: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            }, ],
            valid: false,
            Validate: false,
            clickedAcknowledge: false,
            clickedClose: false,
            clickedCancel:false,
            clickedCompleted:false,
            canSaveRwo: false,
            checkStatusSetting: true,
            tableItems: [],
            tableConfig: {
                name: 'similar_case',
                controls: {
                    reload: false,
                    create: false,
                    delete: false,
                    createPWO: false,
                    enable: false,
                    assign: false,
                    changeStatus: false,
                    tableFilter: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tablePagination: false,
                },
                filter: {},
                page: 1,
                limit: 100,
                total: 0,
                fields: [{
                        key: 'case_number',
                        label: 'Case number',
                        thStyle: "width:70px"
                    },
                    {
                        key: 'location.root_path',
                        label: 'Location',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'service_categories.name',
                        label: 'Service Category',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'feedback_detail',
                        label: 'Description',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'reported_time',
                        label: 'Date & Time Reported',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'unit_no',
                        label: 'Unit No',
                        thStyle: "width:70px"
                    },
                    {
                        key: 'link',
                        label: '',
                        thStyle: "width:70px"
                    }
                ]
            },
            tableConfigNLT: {
                name: 'similar_case_nlt',
                controls: {
                    reload: false,
                    create: false,
                    delete: false,
                    createPWO: false,
                    enable: false,
                    assign: false,
                    changeStatus: false,
                    tableFilter: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tablePagination: false,
                },
                filter: {},
                page: 1,
                limit: 100,
                total: 0,
                fields: [{
                        key: 'case_number',
                        label: 'Case number',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        thStyle: "width:70px"
                    },
                    {
                        key: 'location.root_path',
                        label: 'Location',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'service_categories.name',
                        label: 'Service Category',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'feedback_detail',
                        label: 'Description',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'reported_time',
                        label: 'Date & Time Reported',
                        thStyle: "width:100px"
                    },
                    {
                        key: 'unit_no',
                        label: 'Unit No',
                        thStyle: "width:70px"
                    }
                ]
            },
            timer: {
                fm_staff: null,
                supplier: null,
                company: null,
                contract: null,
                equipment: null,
                location: null,
                requestor: null,
                fault_type: null,
                property: null,
                submit_case: null
            },
            key_search_property: null,
            dataService: [],
            dataProperty: [],
            dataEquipment: [],
            clientContracts: [],
            propertiesContracts: [],
            propertiesTree: null,
            selectRequestors: [],
            selectFaultTypesOptions: [],
            treeProperty: [],
            treeServiceCategory: [],
            treeNatureFeedBack:[],
            treeLocations: [],
            equipment: [],
            locations: [],
            companies: [],
            priority: [],
            timeCurrent: null,
            dateRecorded: null,
            timeRecorded: null,
            pagesEquipment: {
                isCMS: '1',
                limit: 200,
                page: 1,
                totalPage: 0,
                sortColumn: 'tag_name',
                sortDirection: 'ASC',
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            pagesCompanies: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['companies']))
            },
            pagesFmStaff: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['companies']))
            },
            pagesSupplier: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['companies']))
            },
            fm_staff_options: [],
            fm_group_options: [],
            supplier_options: [],
            CaseDetail: null,
            requestor_type:null,
            requestor_field:false,
            // is_tenant_public_company:false,
            
            CaseCreateObj: {
                id: null,
                addresses: null,
                case_number: null,
                isNewRequestor: false,
                contract: null,
                service_location: null,
                reported_date: new Date(moment().format("YYYY-MM-DD")),
                reported_time: moment().format("HH:mm"),
                supplier: null,
                fm_staff: null,
                team_in_charge_id: null,
                avenue_of_feedback: "Call",
                status: 'New',
                attachments: [],
                recorded_by: {
                    name: null,
                    phone: null,
                    email: null
                },
                case_detail: {
                    location: null,
                    service_category: null,
                    // nature_of_feedback: "General Enquiries",
                    nature_feedback:null
                },
                case_requestor:{
                    company_name:null
                },
                requestor: {
                    // requestor_type: "Client",
                    requestor_type: null,
                    company: null,
                    salutation: "Mr",
                    preferred_contact_mode: "Email",
                    secondary_phone: null,
                    primary_phone: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    call_in_phone: null,
                    alternative_phone: null,
                    tags: [],
                    company_name: null
                },
                order: [],
                tags: [],
                custom_fields: []
            },
            clientContract: {
                client: null,
                client_id: 1,
                terms_base: [],
                terms_option: [],
                main_contract: [],
                option_period: [],
                extention_period: [],
                security_deposit: [],
                work_injury_compensation: [],
                public_liability_claim_insurence: [],
                contract_variation: [],
                extension_period_main: [],
                extra_info: [],
                contract_variation_info: [],
                dept_code: '',
                town_council_logo: [],
                debtor_code: ''
            },
            treeData: [],
            selectedNode: null,
            rootId: null,
            opts: {
                minFetchDelay: 500,
                fetchData: (node) => {
                    node.isBatch = false;
                    if (node.data.id == this.rootId) {
                        return new Promise((resolve, reject) => {
                            resolve([]);
                        });
                    }
                    return new Promise((resolve, reject) => {
                        global.axios(`api/properties/tree`, {
                                method: "GET",
                                params: {
                                    property_id: node.data.id
                                },
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                            .then(response => {
                                resolve(response.data.data);
                            })
                            .catch(error => reject(error));
                    });
                }
            },
            checkIsCreateWO:false,
            modals: {
                viewemail:{
                    open:false,
                    loading:false,
                    data:{
                        id:null,
                        to: null,
                        cc:null,
                        subject:null,
                        body:"",
                        remark:null,
                        files: null,
                    },
                    title: 'View Email',
                    iframe:{
                        src:"",
                    },
                    iframeEL: null,
                        
                },
                photo: {
                    open: false,
                    loading: false,
                    attachments: [],
                    modal_attachments: [],
                    attachment_del_ids: [],
                    limitPhoto: 9
                },
                properties: {
                    open: false,
                    loading: false,
                    root_path: null
                },
                cancel:{
                    open:false,
                    loading:false,
                    data:{
                        reason:null
                    }
                },
                warning:{
                    open:false,
                    loading:false
                },
              escalation:{
                title: 'Escalation',
                open:false,
                loading:false,
                loading_content:false,
                data:{
                  caseId: this.$route.params.id,
                  to:null,
                  cc:null,
                  subject:null,
                  body:null,
                },
                editorOption: {
                  theme: 'snow',
                  modules: {
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],
                      ['blockquote', 'code-block'],
                      [{ 'header': 1 }, { 'header': 2 }],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                      [{ 'indent': '-1'}, { 'indent': '+1' }],
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                      [{ 'color': [] }, { 'background': [] }],
                      [{ 'font': [] }],
                      [{ 'align': [] }],
                      ['clean'],
                      ['link'],
                    ]
                  }
                },
              },
                nltNextAction: {
                    open: false,
                    loading: false,
                    data: {
                        status: null
                    },
                    diagramStatus: {
                        "Open": [
                            {
                                value: "nlt-reply-to-eu-fcr",
                                label: "Reply to EU (FCR)"
                            },
                            {
                                value: "nlt-reply-to-eu-first-nfcr",
                                label: "Reply to EU (First NFCR)"
                            },
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Replied to EU (NFCR)": [
                            {
                                value: "nlt-escalate-to-stakeholder",
                                label: "Escalate to Stakeholder"
                            },
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Escalated": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-1st-reminder",
                                label: "Send 1st ST reminder"
                            }
                        ],
                        "1st ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-2nd-reminder",
                                label: "Send 2nd ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "2nd ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-3rd-reminder",
                                label: "Send 3rd ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "3rd ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-4th-reminder",
                                label: "Send 4th ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "4th ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                            {
                                value: "nlt-deadline-passed-timer",
                                label: "Deadline passed (Timer)"
                            },
                        ],
                        "ST Replied": [
                            {
                                value: "nlt-reply-to-eu-final-nfcr",
                                label: "Reply to EU (Final NFCR)"
                            }
                        ],
                        "ST No Response": [
                            {
                                value: "nlt-reply-to-eu-final-nfcr",
                                label: "Reply to EU (Final NFCR)"
                            }
                        ],
                        "Replied to EU (Final NFCR)": [
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Replied to EU (FCR)": [
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                    }
                },
                email:{},
                closeCase: {
                    open: false,
                    loading: false
                },
                nautureOfFeedback: {
                    open: false
                },
                requestorCompany: {
                    open: false
                },
                serviceCategory: {
                    open: false
                },
                avenueOfFeedback: {
                    open: false
                },
                equipment:{
                    open:false
                },
                customEmailPopup:{
                    active: false,
                    minimize: true,
                },
                warningTagsNLT: {
                    open: false,
                    isComplaint: null,
                    valueYes: null,
                    valueNo: null,
                    loading: false
                },
            },
            loading: {
                properties: false,
                createCase: false,
                service_category: false,
                equipment: false,
                company: false,
                priority: false,
                createOrder: false,
                supplier: false,
                fm_staff: false,
                nature_feedback:false
            },
            showNowIcon:false,
            avenueOfFeedbackModel:null,
            normalizerServiceCategory(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    };
                return {
                    id: node.data.id,
                    label: node.name,
                    children: undefined
                };
            },
            normalizerNatureFeedBack(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    };
                return {
                    id: node.data.id,
                    label: node.name,
                    children: undefined
                };
            },
            avenueOfFeedbackOption: [],
            //statusOptions: ["Open", "Repeated Feedback", "Assigned", "PIC Acknowledged", "RWO Issued", "Completed", "Closed"],
            salutationOptions: [],
            requestorTypeOptions: [],
            preferModeOfContactOptions: [],
            natureOfFeedbackOptions: [],
            isAction: false,
            repeatedFeedbackTotal: 0,
            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            is_reset: false,
            selectedLinkToExisting: null,
            optionsLinkToExistingToCompany: [],
            optionsLinkToExistingToUser: [],
            pagesUsers: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['user']))
            },
            optionTags: {
                caseRequestor: [],
                caseInfo: []
            },
            optionsCaseSubLocation: [],
          editorInit: {
            height: 500,
            menubar: false,
            content_style: "body {font-size: 11pt;}",
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
              'table emoticons template paste help'
            ],
            toolbar:
                'formatselect | bold italic backcolor | \
                alignleft aligncenter alignright alignjustify | \
                table  \
                bullist numlist outdent indent | removeformat | help'
          },
          icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
            isMergeCase: true,
            tabActive: null,
            isDisableSave: true
        }
    },
    mixins: [validationMixin],
    validations: {
        CaseCreateObj: {
            case_detail: {
                service_category: {
                    required
                },
                /*location: {
                    required
                },*/
                feedback_detail: {
                    required
                },
                nature_feedback: {
                    required: requiredIf(function (nestedModel) {
                        return this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_nature_of_feedback_mandatory;
                    })
                },
                sla: {
                    required: requiredIf(function (nestedModel) {
                        return this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && !this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module;
                    })
                }
            },
            addresses: {
                required: requiredIf(function (nestedModel) {
                    return !this.CaseCreateObj.isNewRequestor
                })
            },
            fm_staff: {
                //required
                required: requiredIf(function(){
                    return !this.CaseCreateObj.team_in_charge_id
                })
            },
            team_in_charge_id: {
                //required
                required: requiredIf(function(){
                    return !this.CaseCreateObj.fm_staff
                })
            },
            contract: {
                required
            },
            service_location: {
                required
            },
            reported_date: {
                required
            },
            reported_time: {
                required
            },
            requestor: {
                first_name: {
                    required: requiredIf(function (nestedModel) {
                        return this.CaseCreateObj.isNewRequestor
                    })
                },
                company_name: {
                    required: requiredIf(function (nestedModel) {
                        if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module) return true;
                        return this.CaseCreateObj.isNewRequestor && (this.requestor_type && this.requestor_type.data_type && (this.requestor_type.data_type !== 'Generic Address' && this.requestor_type.data_type !== 'Tenant' && this.requestor_type.data_type !== 'NLT Caller Profile'))
                    })
                },
                salutation: {
                    required: requiredIf(function (nestedModel) {
                        return this.CaseCreateObj.isNewRequestor
                    })
                },
                // requestor_type: {
                //     required: requiredIf(function (nestedModel) {
                //         return this.CaseCreateObj.isNewRequestor
                //     })
                // },
                preferred_contact_mode: {
                    required: requiredIf(function (nestedModel) {
                        return this.CaseCreateObj.isNewRequestor
                    })
                },
                email: {
                    required: false
                }
            },
        },
    },
    filters: {
        formatMoney(value) {
            if (!value) return '-';
            return accounting.formatMoney(value, {
                format: {
                    pos: "%s %v",
                    neg: "%s (%v)",
                    zero: "--"
                }
            });
        },
        priceItems: function (data, method, f) {
            let amount = 0;
            let gst = 0;
            let total = 0;
            for (let item of data) {
                amount += parseFloat(item.amount);
                gst += parseFloat(item.gst);
                total += parseFloat(item.total);
            }
            if (method === "amount") {
                return f.formatMoney(amount);
            }
            if (method === "gst") {
                return f.formatMoney(gst);
            }
            return f.formatMoney(total);
        },
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        },
        iconFile(val, icons, is_svg = false) {
            let path = 'img/';
            let type_show = 'img';
            let extension = '';
            let type = val.type || val.image_content_type;

            if(is_svg) {
                path = '';
                type_show = 'svg';
            }
            if(val.type) extension = val.name.split('.')[1];

            let arrTemp = type.split('/');
            if(arrTemp && arrTemp.length == 2) {
                let type = arrTemp[0];
                if(!extension) extension = arrTemp[1];

                if(type == 'application' || type == 'inode' || type == 'text') {
                    let key = 'pdf';
                    if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                    if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                    if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                        let extension = val.image_file_name.split('.')[1];
                        if(['doc', 'docx'].includes(extension)) key = 'word';
                        if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                    }
                    return `${path}${icons['application'][key][type_show]}`;
                }

                return `${path}${icons[type][type_show]}`;
            }
        }
    },
    watch: {

        "CaseCreateObj.contract": function (val, old) {

            this.getRequestorTypeOptions();
            if (val) {
                this.getData()
                if(this.CaseCreateObj.isNewRequestor){
                    if(this.CaseCreateObj.requestor.requestor_type == 'Client' && val.client)
                        this.CaseCreateObj.requestor.company = val.client
                    if(this.CaseCreateObj.requestor.requestor_type == 'FM Staff' && val.supplier)
                        this.CaseCreateObj.requestor.company = val.supplier
                }
                if (old && old.id !== val.id) {
                    this.CaseCreateObj.service_location = null;
                    this.CaseCreateObj.case_detail.service_category = null;
                    this.CaseCreateObj.case_detail.nature_feedback = null;
                    this.CaseCreateObj.fm_staff = null;
                    this.CaseCreateObj.team_in_charge_id = null;
                    this.CaseCreateObj.case_detail.sla = null;
                    this.CaseCreateObj.case_detail.equipment = [];
                    this.equipment = [];
                }
                this.loadRootServiceCategory();
                this.loadRootNatureFeedBack();
                this.getTags("caseRequestor", "Tags - Case Requestor");
                this.getTags("caseInfo", "Tags - Case Info");
                this.getAvenueOfFeedbackOption();
                this.getSalutations();
                this.getPreferredMode();
                this.loadSLAByServiceCate()
                if(this.$route.params.id == 0) {
                    this.getCustomFields();
                }
                if(val.case_settings && !val.case_settings.is_free_text_for_unit_no) {
                    this.getCaseSubLocation();
                }
                // callback Contract selector
                if(val.id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != val.id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', val.id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }
            } else {
                this.treeProperty = [];
                this.CaseCreateObj.service_location = null;
                this.treeServiceCategory = [];
                this.treeNatureFeedBack = [];
                this.CaseCreateObj.case_detail.service_category = null
                this.CaseCreateObj.case_detail.nature_feedback = null
                this.propertiesContracts = [];
            }
            // if(this.requestor_type){
            //     this.searchRequestor('',()=>{})
            // }
            this.loadSupplier();
            this.loadFmStaff();
            this.loadFMTeam();
            this.searchProperty('', () => {});
            this.modals.properties.root_path = null;
        },
        "CaseCreateObj.fm_staff": function (val) {
            if (val && !this.CaseCreateObj.work_order_id) {
                if(this.CaseCreateObj.supplier){
                    this.canSaveRwo = true;
                }
            } else {
                this.canSaveRwo = false;
            }

            this.loadCheckStatusSetting()

            // if(!this.CaseCreateObj.id && val) {
            //     this.CaseCreateObj.team_in_charge_id = null;
            //     return;
            // }

            // if(val && val.user_id && (this.CaseCreateObj.status === 'Open' || this.CaseCreateObj.status === 'Assigned')){
            //     this.CaseCreateObj.team_in_charge_id = null;
            // }

            // if(val && this.CaseCreateObj.status === 'PIC Acknowledged'){
            //     if(val.user_id !== this.CaseDetail.officer_in_charge_id || this.CaseCreateObj.team_in_charge_id !== this.CaseDetail.team_in_charge_id){
            //         this.CaseCreateObj.team_in_charge_id = null;
            //     }
            // }
        },
        "CaseCreateObj.team_in_charge_id": function (val) {
            // if(!this.CaseCreateObj.id && val) {
            //     this.CaseCreateObj.fm_staff = null;
            //     return;
            // }
            // if(val && (this.CaseCreateObj.status === 'Open' || this.CaseCreateObj.status === 'Assigned')){
            //     this.CaseCreateObj.fm_staff = null;
            // }
            // if(val && this.CaseCreateObj.status === 'PIC Acknowledged'){
            //     if(this.CaseCreateObj.team_in_charge_id !== this.CaseDetail.team_in_charge_id || (this.CaseCreateObj.fm_staff  && this.CaseCreateObj.fm_staff.user_id !== this.CaseDetail.officer_in_charge_id)){
            //         this.CaseCreateObj.fm_staff = null;
            //     }
            // }
        },
        "CaseCreateObj.supplier": function (val) {
            if (val && !this.CaseCreateObj.work_order_id) {
                if(this.CaseCreateObj.fm_staff){
                    this.canSaveRwo = true;
                }
            } else {
                this.canSaveRwo = false;
            }
            this.loadCheckStatusSetting()
        },
        "CaseCreateObj.case_detail.location": function (val, old) {
            if(this.CaseCreateObj.contract.case_settings && !this.CaseCreateObj.contract.case_settings.is_free_text_for_unit_no) {
                this.getCaseSubLocation();
            }

            if(!this.CaseCreateObj.case_detail.service_category){
                this.equipment = [];
                this.CaseCreateObj.case_detail.equipment = [];
                return;
            }
            if(!old || !val || val && old && val.id && old.id && val.id != old.id) {
                this.getEquipment();
            }
        },
        "CaseCreateObj.requestor.requestor_type": function (val, old) {
            // this.is_tenant_public_company = false;
            switch (val) {
                case "Client":
                    this.pagesCompanies.filter.is_client.value = true;
                    this.pagesCompanies.filter.is_supplier.value = null;
                    this.pagesCompanies.filter.is_fm_company.value = null;
                    //this.CaseCreateObj.requestor.company = null;
                    this.loadCompany();
                    break;
                case "Supplier":
                    this.pagesCompanies.filter.is_supplier.value = true;
                    this.pagesCompanies.filter.is_fm_company.value = null;
                    this.pagesCompanies.filter.is_client.value = null;
                    //this.CaseCreateObj.requestor.company  = null;
                    this.loadCompany();
                    break;
                case "FM Staff":
                    this.pagesCompanies.filter.is_supplier.value = false;
                    this.pagesCompanies.filter.is_fm_company.value = true;
                    this.pagesCompanies.filter.is_client.value = null;
                    //this.CaseCreateObj.requestor.company  = null;
                    this.loadCompany();
                    break;
                default:
                    this.companies = [];
                    // this.is_tenant_public_company = true;
            }
            if (val) {
                //this.CaseCreateObj.requestor.company = null;
            }
        },
        "CaseCreateObj.case_detail.service_category": function (val, old) {
            if(!val){
                this.equipment =  [];
                this.CaseCreateObj.case_detail.equipment = [];
                return;
            }
            if(!old || !val || val && old && val.id && old.id && val.id != old.id) {
                this.getEquipment();
                this.getFaultTypesOptions();
                this.loadSLAByServiceCate();
            }
        },
        "CaseCreateObj.case_detail.fault_type": function (val, old) {
            let is_reset_fault_type = ( (this.$route.params.id == "0" && val) || (this.$route.params.id != "0" && (val && old && val.id && old.id && val.id != old.id) || (val && old === null)) ) ? true : false;
            this.loadSLAByServiceCate(is_reset_fault_type);
        },
        "CaseCreateObj.isNewRequestor":function(val){
            if(val){
                this.resetRequestor();
                // this.CaseCreateObj.requestor.company = this.CaseCreateObj.contract && this.CaseCreateObj.contract.client ? this.CaseCreateObj.contract.client:null
            }
        },
        ClientContractID: function (val) {
            if (this.$route.params.id == "0") {
                if(val && val.hasOwnProperty('id') && val.case_setting_module == 'Hot-Button') {
                    this.$router.push({
                        name: 'case-detail-hb-info',
                        params: {
                            id: 0
                        }
                    })
                    return
                }
                this.CaseCreateObj.contract = (val && val.hasOwnProperty('id')) ? val : null;
            }
        },
        Item: function(val) {
            if(this.tabActive && this.tabActive == 'activity-log' && val && this.CaseCreateObj.id && val.status != this.CaseCreateObj.status) {
                this.setDataToCaseObj(val)
            }
        },
        /*'modals.warningTagsNLT.isComplaint': function () {
            this.modals.warningTagsNLT.valueYes = this.modals.warningTagsNLT.valueNo = null
        }*/
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            ClientContractID: 'ContractController/ClientContractID',
            Item: "CaseManagementController/Item",
        }),
        ...mapGetters({
            UserLogin: 'AuthController/user',
        }),
        nltStatus() {
            if(this.CaseCreateObj.status && this.modals.nltNextAction.diagramStatus[this.CaseCreateObj.status]) return this.modals.nltNextAction.diagramStatus[this.CaseCreateObj.status];
            return [];
        },
        isAmendCase() {
            if(!this.CaseCreateObj || this.CaseCreateObj.status != 'Closed') return false
            if(this.$disabledCreateOrUpdate(this.CaseCreateObj, this.$accessModule.case_management) || !this.$checkRole(this.$accessModule.amend_closed_case_details, 'amend_closed_case_details')) return false
            return true
        },
        isDisableSaveOfNLT() {
            if(this.CaseCreateObj && this.CaseCreateObj.id) {
                if(this.CaseCreateObj.status == 'Closed') {
                    if(!this.isAmendCase) return true
                    return this.isDisableSave
                }
            }
            return this.$disabledCreateOrUpdate(this.CaseCreateObj, this.$accessModule.case_management)
        }
    },
    mounted: function () {
        this.modals.viewemail.iframeEL=this.$refs.iframeNew;
        window.onpopstate = (event) => {
            if(this.$route.params.id == '0'){
                this.resetCaseData();
                return;
            }
            if(this.$route.params.id){
                this.loadData();
            }
        }
    },
    async created() {
        this.loadData();
    },
    updated() {
        this.$nextTick(() => {
            if(this.$refs.goFixTab)
                this.$refs.goFixTab.handleResize();
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        clickCancel(){
            if(this.CaseCreateObj && this.CaseCreateObj.work_order_id){
                this.modals.warning.open = true;
                return;
            }
            this.openReasonCancelCase();
        },
        cancelRedirect(){
            // let email_id=$route.params.email_id;
            if(this.isAction) return;
            this.isAction = true;

            let params = Object.assign({
                        email_id: this.$route.params.email_id,
                        locked:false
                    });

            this.$store.dispatch("EmailIntegrationController/locked", params)
                .then(response => {
                    this.isAction = false;
                    if(response.data.data == 1){
                        // this.modals.assign.email_id=SelectedItem.id;
                        // this.modals.assign.open=true;
                        this.$router.push(`/case/emails/inbox`);
                    }
                })
                .catch(err => {
                  this.isAction = false;
                  return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");

                })


            // alert("cancel is on "+this.$route.params.email_id);


        },
        openReasonCancelCase(){
            this.modals.cancel.open = true;
            this.modals.warning.open = false;
        },
        updateCaseCancellation(){
            if(!this.modals.cancel.data.reason){
                return this.$alertNotification("You must provide Reason for Cancellation!", "danger");
            }
            let request = {
                status: "Cancelled",
                reason:this.modals.cancel.data.reason,
                id: parseInt(this.$route.params.id)
            }
            this.clickedCancel = !this.clickedCancel;
            this.$store.dispatch('CaseManagementController/raiseCase', request)
                .then(async (result) => {
                    this.getCaseEdit(result.data.data.id)
                    this.modals.cancel.open = false;
                    this.modals.cancel.loading = false;
                    await this.$alertNotification(this.$notificationV2('editing', 'case'));
            }).catch(err => {
                this.modals.cancel.loading = false;
                if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "warning");
                }
            })
        },
        getSupplierLevel1(val){
            if(val && val.length === 1){
                this.CaseCreateObj.supplier = val[0];
            }else if(val.length === 0){
                this.CaseCreateObj.supplier = null;
            }
        },
        handleResize() {
            this.modals.photo.limitPhoto = 9
            if (window.innerWidth < 1500) {
                this.modals.photo.limitPhoto = 5
            }
            if (window.innerWidth >= 1500 && window.innerWidth < 1920) {
                this.modals.photo.limitPhoto = 7
            }
        },
        /*-- Photo ----------------------------------------------------------*/
        updateDataPhoto(data) {
            this.modals.photo.attachments        = data.attachments;
            this.modals.photo.attachment_del_ids = data.attachment_del_ids;
            this.modals.photo.modal_attachments  = data.modal_attachments;
            this.uploadPhotos();
        },
        async uploadPhotos(showMsg = 1) {
            if (!this.CaseCreateObj.id) {
                this.CaseCreateObj.attachments = this.modals.photo.modal_attachments;
                this.modals.photo.open = false;
                return;
            }

            this.modals.photo.loading = true;
            if(this.modals.photo.attachment_del_ids.length > 0) {
                await this.$store.dispatch("AttachmentController/removeAttachments", {
                    ids: this.modals.photo.attachment_del_ids
                })
            }

            await this.$store.dispatch("AttachmentController/createAttachmentWithType", {
                id: this.CaseCreateObj.id,
                attachments: this.modals.photo.attachments,
                type: 'cases'
            })
            .then(response => {
                this.modals.photo.loading = false;
                this.modals.photo.open = false;
                if (showMsg) {
                    this.$alertNotification(this.$notificationV2('adding', 'attachment'));
                }
            })
            .catch(err => {
                console.log(err);
                this.modals.photo.loading = false;
            });

            if(this.CaseCreateObj.id) this.getCaseEdit(this.CaseCreateObj.id);
        },
        async getFaultTypesOptions(filter = null) {
            let service_category_id = this.CaseCreateObj.case_detail.service_category ? this.CaseCreateObj.case_detail.service_category.id : 0
            let params = {
                filter: filter,
                limit: 100,
                isCMS: 1,
                sortColumn: 'fault_name',
                sortDirection: 'ASC',
                service_category_id: service_category_id
            }
            await this.$store.dispatch(`FaultTypeController/getItems`, params)
                .then(response => {
                    this.selectFaultTypesOptions = response.items;
                })
        },
        async searchFaultType(search, loading) {
            loading(true);
            this.selectFaultTypesOptions = []
            if (this.timer.fault_type) {
                clearTimeout(this.timer.fault_type);
                this.timer.fault_type = null;
            }
            this.timer.fault_type = setTimeout(async () => {
                let filter = {
                    "fault_name": {
                        "type": "text",
                        "value": search,
                        "function": "ilike",
                        "with": []
                    }
                }
                await this.getFaultTypesOptions(filter);
                await loading(false);
            }, 500);
        },
        selectedRequestorType(val){
            if(val){
                this.requestor_field = true
            }
            this.searchRequestor("", ()=>{})
            this.loadOptionsLinkToExisting();
        },
        selectedRequestor(val) {
            if (val) {
                this.CaseCreateObj.requestor.salutation = val.salutation;
                this.CaseCreateObj.requestor.first_name = val.first_name;
                this.CaseCreateObj.requestor.last_name = val.last_name;
                this.CaseCreateObj.requestor.email = val.email;
                this.CaseCreateObj.requestor.primary_phone = val.primary_phone;
                this.CaseCreateObj.requestor.secondary_phone = val.secondary_phone;
                this.CaseCreateObj.requestor_id = val.id;
                this.CaseCreateObj.requestor.preferred_contact_mode = val.preferred_contact_mode || "Email";
                // this.CaseCreateObj.requestor.company_name = val.organizations && val.organizations.name ? val.organizations.name : null
                this.CaseCreateObj.requestor.company_name = val.company_name || null
                this.CaseCreateObj.requestor.requestor_company_id = val.requestor_company_id || null
                // this.CaseCreateObj.requestor.requestor_type = val.requestor_type || "Client"
                this.CaseCreateObj.requestor.requestor_type = val.requestor_type || null
                this.CaseCreateObj.requestor.requestor_user_id = val.user_id || null
                this.CaseCreateObj.requestor.call_in_phone  = val.call_in_phone || null
                this.CaseCreateObj.requestor.alternative_phone = val.alternative_phone || null
                this.CaseCreateObj.requestor.tags = val.tags || null
            }
        },
        // selectedRequestorTypeTwo(val){
        //     if(val == 'Client'){
        //         this.CaseCreateObj.requestor.company = this.CaseCreateObj.contract && this.CaseCreateObj.contract.client ? this.CaseCreateObj.contract.client : null;
        //     }
        //     if(val == 'FM Staff'){
        //         this.CaseCreateObj.requestor.company = this.CaseCreateObj.contract && this.CaseCreateObj.contract.supplier ? this.CaseCreateObj.contract.supplier : null;
        //     }
        //     //this.CaseCreateObj.requestor.company = null;
        // },
        refreshStatus() {
            if (this.CaseCreateObj.fm_staff && this.CaseCreateObj.fm_staff.user_id != this.UserLogin.id) {
                this.clickedAcknowledge = false;
                this.clickedClose = false;
            }
        },
        clickAcknowledge() {
            this.validateWhenSubmit();
            if (!this.valid) {
                return;
            }
            this.clickedAcknowledge = !this.clickedAcknowledge;
            this.CaseCreateObj.status = "PIC Acknowledged";
            this.save(1);
        },
        clickOnSite() {
            this.validateWhenSubmit();
            if (!this.valid) {
                return;
            }
            this.CaseCreateObj.status = "On Site";
            this.save(1);
        },
        clickInProgress() {
            this.validateWhenSubmit();
            if (!this.valid) {
                return;
            }
            this.CaseCreateObj.status = "In Progress";
            this.save(1);
        },
        clickComplete() {
            this.validateWhenSubmit();
            if (!this.valid) {
                return;
            }
            this.clickedCompleted = !this.clickedCompleted;
            this.CaseCreateObj.status = "Completed";
            this.save(1);
        },
        clickClose() {
            let request = {
                status: "Closed",
                id: parseInt(this.$route.params.id)
            }
            if (!this.Item || (this.Item.case_action_taken_id === null || this.Item.case_work_finding_id === null)) {
                return this.$alertNotification("Kindly input under the Case Reporting tab your Work Findings and Action Taken for this case to be closed.", "danger");
            }
            this.clickedClose = !this.clickedClose;
            this.$store.dispatch('CaseManagementController/raiseCase', request)
                .then(async (result) => {
                    this.CaseCreateObj.status = await result.data.data.status;
                    await this.getCaseEdit(result.data.data.id);
                    await this.$alertNotification(this.$notificationV2('editing', 'case'));
                }).catch(err => {
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "warning");
                    }
                })
        },
        clickRaiseAnotherRWO() {
            let request = {
                type: "Case",
                item_id: this.CaseCreateObj ? this.CaseCreateObj.id : null,
                supplier_id: this.CaseCreateObj ? this.CaseCreateObj.supplier_id : null,
                officer_in_charge_id: this.CaseCreateObj ? this.CaseCreateObj.officer_in_charge_id : null,
                team_in_charge_id: this.CaseCreateObj ? this.CaseCreateObj.team_in_charge_id : null,
            };
            this.$store.dispatch(`OrderController/raiseOrder`, request)
                .then(response => {
                    this.$router.push(`/v2/orders/` + response.id)
                })
                .catch(err => {
                    this.modals.order.loading = false;
                    this.$alertNotification("Can't create order", "danger");
                });
        },
        refreshData() {
            this.CaseCreateObj.service_location = null;
            this.CaseCreateObj.case_detail.service_category = null;
        },
        getCaseEdit(val) {
            this.is_reset = true;
            let case_id = this.$route.params.id;
            if(val){
                case_id =  val
            }
            this.$store.dispatch('CaseManagementController/getCase', {
                    case_id: case_id
                })
                .then(response => {
                    let obj = response.data.data;
                    this.setDataToCaseObj(obj);
                    this.searchRequestor('',()=>{})
                    this.loadCheckStatusSetting()
                    if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module) {
                        let arrFind = this.tabData.filter(item => item.key == 'case-kpi');
                        if(!arrFind.length) {
                            this.tabData.push({
                                key: "case-kpi",
                                title: "Case KPI",
                                active: false
                            })
                        }
                    }else{
                        let arrFindFB = this.tabData.filter(item => item.key == 'repeated-feedback');
                        if(!arrFindFB.length) {
                            this.tabData.push({
                                key: "repeated-feedback",
                                title: "Repeated Feedback",
                                active: false
                            })
                        }
                    }
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case", "danger");
                })
        },
        setDataToCaseObj(obj) {
            if (!obj.recorded_by) {
                obj.recorded_by = {
                    name: null,
                    phone: null,
                    email: null
                }
            }
            this.timeCurrent = obj.recorded_time;
            this.dateRecorded = moment(obj.recorded_time).format("DD.MM.YYYY");
            this.timeRecorded = moment(obj.recorded_time).format("HH:mm");
            this.CaseCreateObj.attachments = [];
            let arrType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
            let attachments = obj.attachments.filter(item => arrType.includes(item.image_content_type))
            //
            if(obj.avenue_of_feedback || obj.avenue_feedback_type) this.avenueOfFeedbackModel = {reference_value_text:obj.avenue_of_feedback,reference_value_abbr:obj.avenue_feedback_type};
            this.CaseDetail = obj;
            this.CaseCreateObj = Object.assign(this.CaseCreateObj, obj, {
                addresses: obj.case_requestor.addresses,
                description: obj.feedback_detail,
                reported_date: new Date(moment(obj.reported_time).format("YYYY-MM-DD")),
                reported_time: moment(obj.reported_time).format("HH:mm"),
                service_location: obj.properties,
                fm_staff: obj.user ? {
                    user_id: obj.user.id,
                    user_name: obj.user.name,
                    role_name: obj.user.roles[0].name,
                    user_team: obj.user.user_team,
                } : null,
                requestor: {
                    requestor_type: obj.case_requestor && obj.case_requestor.requestor_type,
                    // company: obj.case_requestor && obj.case_requestor.organizations,
                    id: obj.case_requestor.id,
                    salutation: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.salutation,
                    first_name: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.first_name,
                    last_name: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.last_name,
                    email: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.email,
                    primary_phone: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.primary_phone,
                    preferred_contact_mode: (obj.case_requestor && obj.case_requestor.preferred_contact_mode) ? obj.case_requestor.preferred_contact_mode : "Email",
                    secondary_phone: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.secondary_phone,
                    company_name: obj.case_requestor && obj.case_requestor.company_name,
                    requestor_company_id: obj.case_requestor && obj.case_requestor.requestor_company_id,
                    requestor_user_id: obj.case_requestor && obj.case_requestor.user_id,
                    call_in_phone: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.call_in_phone,
                    alternative_phone: obj.case_requestor && obj.case_requestor.addresses && obj.case_requestor.addresses.alternative_phone,
                    tags: obj.case_requestor && obj.case_requestor.tags,
                },
                case_detail: {
                    // nature_of_feedback: obj.nature_of_feedback,
                    nature_feedback: obj.nature_feedback,
                    location: obj.location,
                    service_category: obj.service_categories,
                    sla: obj.sla,
                    equipment: obj.equipment,
                    fault_type: obj.fault_type,
                    feedback_detail: obj.feedback_detail,
                    unit_no: obj.unit_no
                },
                attachments: attachments
            });
            this.requestor_type = this.CaseCreateObj.case_requestor_type
            this.CaseCreateObj.isNewRequestor = false;
        },
        async getTableData(callback) {
            const {
                tableRequest,
                resolve,
                reject
            } = await callback();
            tableRequest.filter.service_category_id = this.CaseCreateObj.case_detail.service_category.id;
            tableRequest.filter.location_id = (this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id) ? this.CaseCreateObj.case_detail.location.id : null;
            tableRequest.filter.get_similar_case = true
            tableRequest.filter.client_contract_id = this.CaseCreateObj.contract.id
            tableRequest.isCMS = 0;
            await this.$store.dispatch("CaseManagementController/getSimilarCase", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification(err, "danger");
                    reject();
                })
        },
        async getTableDataNLT(callback) {
            const {
                tableRequest,
                resolve,
                reject
            } = await callback();

            
            tableRequest.filter.location_id = (this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id) ? this.CaseCreateObj.case_detail.location.id : null;
            tableRequest.filter.client_contract_id = this.CaseCreateObj.contract.id
            tableRequest.filter.unit_no = this.CaseCreateObj.case_detail.unit_no || null
            
            await this.$store.dispatch("CaseManagementController/getSimilarCaseNLT", tableRequest)
            .then(response => {
                this.tableItems = response.data.data.items;
                this.tableConfig.total = response.data.data.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification(err, "danger");
                reject();
            })
        },
        checkSaveCase(val){
            if(val){
                this.save(1,true);
            }
            else{
                this.save(1);
            }
        },
        modalMergeCase(val) {
          if(this.isAction) return;
          this.isAction = true;
            this.validateWhenSubmit();
            // if (!this.CaseCreateObj.service_location) {
            //     this.Validate = true;
            //     return this.$bvToast.toast('Service Location  is a required field.', {
            //         title: `Notification`,
            //         autoHideDelay: 3000,
            //         variant: 'danger',
            //         solid: true
            //     })
            // }

            // if (!this.CaseCreateObj.case_detail.service_category) {
            //     this.Validate = true;
            //     return this.$bvToast.toast('Service Category is a required field.', {
            //         title: `Notification`,
            //         autoHideDelay: 3000,
            //         variant: 'danger',
            //         solid: true
            //     })
            // }
            if (!this.valid) {
              this.isAction = false;
                return
            }

            if(!this.CaseCreateObj.case_detail.location) {
              this.isAction = false;
                this.checkSaveCase(val);
                return;
            }
            //
            if(this.ClientContractID &&
                this.ClientContractID.case_settings &&
                this.ClientContractID.case_settings.is_use_nlt_case_module){
              this.isAction = false;
              this.checkSaveCase(val);

                return;
            }
            // debugger
            const tableRequest = {
                filter: {}
            };
            tableRequest.filter.service_category_id = this.CaseCreateObj.case_detail.service_category.id;
            tableRequest.filter.location_id = (this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id) ? this.CaseCreateObj.case_detail.location.id : null;
            tableRequest.filter.get_similar_case = true
            tableRequest.filter.client_contract_id = this.CaseCreateObj.contract.id
            tableRequest.isCMS = 0;
            this.isMergeCase = false
            this.$store.dispatch("CaseManagementController/getSimilarCase", tableRequest)
                .then(response => {
                    this.isAction = false;
                    if (response.data.data.items.length == 0) {
                        this.CaseCreateObj.status = this.Item && this.Item.status ? this.Item.status : null
                        this.checkSaveCase(val);
                    } else {
                        if(val){
                            this.checkIsCreateWO = true;
                        }else{
                            this.checkIsCreateWO = false;
                        }
                        this.$refs['modal-merge-case'].show();
                    }
                })
                .catch(err => {
                  this.isAction = false;
                    this.$alertNotification("Can not load the similar case", "danger");
                })

        },
        hideModalMergeCase() {
            this.CaseCreateObj.status = this.Item && this.Item.status ? this.Item.status : null
            this.isMergeCase = true
        },
        raiseNewCase(obj, createRWO = false) {
            this.CaseCreateObj.status = this.Item && this.Item.status ? this.Item.status : 'Open';
            this.save(obj, createRWO)
        },
        raiseNewCaseNLT(obj, createRWO = false) {
            this.CaseCreateObj.status = this.Item && this.Item.status ? this.Item.status : 'New';
            this.$refs['cases-similar-nlt'].hide();
            this.save(obj, createRWO, 'similar-nlt')
        },
        gotoDetail(item) {
            if (item.id) {
                window.open(`#/v2/case/${item.id}`);
            }
        },
        async save(obj, createRWO, similarNLT = '') {
            if(this.isAction) return;
            this.isAction = true;
            this.validateWhenSubmit();
            if (!this.valid) {
                this.isAction = false;
                return
            }
            
            /* begin detect existing cases of the same property */
            if(!this.CaseCreateObj.id && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module == true && this.CaseCreateObj.contract.case_settings.detect_existing_cases_of_the_same_property == true && similarNLT != 'similar-nlt') {

                const tableRequest = {
                    filter: {}
                };

                this.tableConfigNLT.total = 0
                this.tableConfigNLT.total = 0
                this.tableItems = []

                tableRequest.filter.location_id = (this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id) ? this.CaseCreateObj.case_detail.location.id : null;
                tableRequest.filter.client_contract_id = this.CaseCreateObj.contract.id
                tableRequest.filter.unit_no = this.CaseCreateObj.case_detail.unit_no || null

                let respo_ = await this.$store.dispatch("CaseManagementController/getSimilarCaseNLT", tableRequest)
                .then(response => {
                    if (response.data.data.items.length == 0) {
                        //
                    } else {
                        this.$refs['cases-similar-nlt'].show();
                        return false;
                    }
                })
                .catch(err => { });

                if ( respo_ == false ) {
                    this.isAction = false;
                    return;
                }
            }
            
            /* end detect existing cases of the same property */

            if(this.CaseCreateObj.id && this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && !this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module) {
                this.isAction = false;
                if(!this.Item.service_category_id) {
                    if(!this.$refs['modal-merge-case'].isShow && this.isMergeCase) {
                        this.isMergeCase = true
                        this.CaseCreateObj.status = 'Repeated Feedback'
                        this.modalMergeCase(createRWO ? 1 : 0)
                        return
                    }
                }
            }

            let case_number = null;
            if (obj == 1) {
                //new case
                case_number = this.CaseCreateObj.case_number;
            } else {
                //link
                case_number = obj.case_number;
            }
            var reported_time = null;

            if (this.CaseCreateObj.reported_date && this.CaseCreateObj.reported_time) {
                //Check vaidate reported_time
                let reported_time_validate = this.CaseCreateObj.reported_time;
                reported_time_validate = reported_time_validate.split(':');
                if(reported_time_validate[0] == 'HH' || reported_time_validate[1] == 'mm'){
                  this.isAction = false;
                    return this.$alertNotification("Please enter the exact Time Reported field", "danger");
                }
                //console.log(this.CaseCreateObj.reported_time);

                let time = moment(this.CaseCreateObj.reported_date).format("YYYY-MM-DD") + " " + this.CaseCreateObj.reported_time

                reported_time = moment(time, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
            }
            let request = {
                recorded_time: this.timeCurrent,
                case_number: case_number,
                preferred_contact_mode: this.CaseCreateObj.requestor.preferred_contact_mode,
                requestor_id: this.CaseCreateObj.requestor_id,
                // requestor_type: this.CaseCreateObj.requestor.requestor_type,
                feedback_detail: this.CaseCreateObj.case_detail.feedback_detail,
                unit_no: this.CaseCreateObj.case_detail.unit_no,
                avenue_of_feedback: (this.avenueOfFeedbackModel) ? this.avenueOfFeedbackModel.reference_value_text:null,
                avenue_feedback_type:(this.avenueOfFeedbackModel) ? this.avenueOfFeedbackModel.reference_value_abbr:null,
                nature_of_feedback: this.CaseCreateObj.case_detail.nature_feedback && this.CaseCreateObj.case_detail.nature_feedback.id ? this.CaseCreateObj.case_detail.nature_feedback.name : null,
                nature_feedback_id: this.CaseCreateObj.case_detail.nature_feedback && this.CaseCreateObj.case_detail.nature_feedback.id ? this.CaseCreateObj.case_detail.nature_feedback.id : null,
                requestor_company_id: this.CaseCreateObj.requestor.requestor_company_id ? this.CaseCreateObj.requestor.requestor_company_id : null,
                company_name: (this.CaseCreateObj.requestor && this.CaseCreateObj.requestor.company_name)?this.CaseCreateObj.requestor.company_name:'',
                equipment_ids: (this.CaseCreateObj.case_detail.equipment && this.CaseCreateObj.case_detail.equipment.length > 0) ? JSON.stringify(this.CaseCreateObj.case_detail.equipment.map(x => x.id)) : null,
                addresses: {
                    first_name: this.CaseCreateObj.requestor.first_name,
                    last_name: this.CaseCreateObj.requestor.last_name,
                    salutation: this.CaseCreateObj.requestor.salutation,
                    email: this.CaseCreateObj.requestor.email,
                    primary_phone: this.CaseCreateObj.requestor.primary_phone,
                    secondary_phone: this.CaseCreateObj.requestor.secondary_phone,
                    call_in_phone: this.CaseCreateObj.requestor.call_in_phone,
                    alternative_phone: this.CaseCreateObj.requestor.alternative_phone,
                },
                reported_time: reported_time,
                client_contract_id: this.CaseCreateObj.contract.id,
                property_id: this.CaseCreateObj.service_location && this.CaseCreateObj.service_location.id,
                location_id: (this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id) ? this.CaseCreateObj.case_detail.location.id:null,
                priority: this.CaseCreateObj.case_detail.sla && this.CaseCreateObj.case_detail.sla.id,
                service_category_id: this.CaseCreateObj.case_detail.service_category && this.CaseCreateObj.case_detail.service_category.id,
                supplier_id: this.CaseCreateObj.supplier && this.CaseCreateObj.supplier.id,
                officer_in_charge_id: this.CaseCreateObj.fm_staff ? this.CaseCreateObj.fm_staff.user_id : null,
                team_in_charge_id: this.CaseCreateObj.team_in_charge_id,
                work_order_id: this.CaseCreateObj.work_order_id,
                status: this.CaseCreateObj.status,
                id: parseInt(this.$route.params.id),
                isNewRequestor: !!this.CaseCreateObj.isNewRequestor,
                fault_type_id: this.CaseCreateObj.case_detail.fault_type && this.CaseCreateObj.case_detail.fault_type.id,
                raise_work_order: createRWO,
                requestor_type: this.requestor_type && this.requestor_type.data_type ? this.requestor_type.data_type : null,
                requestor_user_id: this.CaseCreateObj.requestor.requestor_user_id ? this.CaseCreateObj.requestor.requestor_user_id : null,
                custom_fields: this.CaseCreateObj.custom_fields ? this.CaseCreateObj.custom_fields : [],
                case_requestor_type_id: this.requestor_type && this.requestor_type.id ? this.requestor_type.id : null,
                email_id: !!this.$route.params.email_id ? this.$route.params.email_id : null,
                tags: null,
                requestor_tags: null,
            }






            if(this.CaseCreateObj.tags && this.CaseCreateObj.tags.length) {
                request.tags = this.CaseCreateObj.tags.map(item => {
                    return {
                        id: item.id,
                        reference_value_text: item.reference_value_text
                    }
                })
            }

            if(this.CaseCreateObj.requestor.tags && this.CaseCreateObj.requestor.tags.length) {
                request.requestor_tags = this.CaseCreateObj.requestor.tags.map(item => {
                    return {
                        id: item.id,
                        reference_value_text: item.reference_value_text
                    }
                })
            }

            let keyMessage = 'adding'
            if (this.$route.params.id != "0") {
                keyMessage = 'editing'
            }
            this.$store.dispatch('CaseManagementController/raiseCase', request)
                .then(async (result) => {
                    this.$refs['modal-merge-case'].hide();
                    if (createRWO && this.UserLogin.organization.is_fm_company) {
                        await this.$router.push(`/v2/orders/` + result.data.data.work_order_id)
                        await this.$alertNotification(this.$notificationV2('adding', 'order'));
                    } else {
                        if(result.data.data.status === 'Assigned'){
                            this.clickedAcknowledge = false;
                        }
                        if (this.$route.params.id == "0") {
                            this.CaseCreateObj.id = await result.data.data.id;
                            await this.uploadPhotos(0);
                            let linkRedirect = '/case/';
                            if(this.$route.name == 'case-detail') linkRedirect = '/case/';
                            await this.$router.push(linkRedirect + result.data.data.id);
                            this.modals.customEmailPopup.active = false;
                        }
                        await this.getCaseEdit(result.data.data.id)
                        await this.$alertNotification(this.$notificationV2(keyMessage, 'case'));
                        this.isDisableSave = true;
                    }
                    this.isAction = await false;
                    this.modals.warningTagsNLT.open = this.modals.warningTagsNLT.loading = false
                }).catch(err => {
                    this.isAction = false;
                    this.isDisableSave = true;
                    this.modals.warningTagsNLT.open = this.modals.warningTagsNLT.loading = false
                    if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "warning");
                    }
                })
        },
        loadRootServiceCategory() {
            this.loading.service_category = true;
            global.axios(`api/contracts/${this.CaseCreateObj.contract.id}/tree-service-categories/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    this.treeServiceCategory = response.data.data;
                    this.loading.service_category = false;

                }).catch(error => {});
        },
        setContractInfo(contract) {
                this.clientContract.security_deposit_main = this.clientContract.contact_variation_main = [];
                if (contract != null) {

                    this.formatData(contract.terms_base, 'base');
                    // this.formatData(contract.terms_option, 'option');
                    // this.formatData(contract.extension_period_main, 'extension_period_main');
                    // this.formatData(contract.extra_info, 'extra_info');
                    // this.formatData(contract.contract_variation_info, 'contract_variation_info');
                    this.clientContract = Object.assign({}, contract)
                    this.clientContract.contract_id = contract.id
                }
            },
        formatData(temp, type ="base") {
                if(!temp || !temp.length) {
                    if(type == 'base') {
                        temp.push({
                            id: '',
                            term_type: type,
                            start_date: null,
                            end_date: null,
                            contract_sum: '',
                            sor_adjustment: '',
                            data: {}
                        });
                    }
                    return;
                }

                if(type == 'contract_variation_info') {
                    temp.forEach(function(item) {
                        item.json_content.amount = JSON.stringify(item.json_content.amount)
                    });
                    return;
                }

                //type: extra_info
                if(type == "extra_info") {
                    temp.forEach(function(item) {
                        //Security deposit
                        item.security_deposit.json_content.amount = JSON.stringify(item.security_deposit.json_content.amount);
                        //Work injury compensation
                        item.work_injury_compensation.json_content.policy_premium = JSON.stringify(item.work_injury_compensation.json_content.policy_premium)
                        item.work_injury_compensation.json_content.issue_date = item.work_injury_compensation.json_content.issue_date ? new Date(moment(item.work_injury_compensation.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.start_date = item.work_injury_compensation.json_content.start_date ? new Date(moment(item.work_injury_compensation.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.end_date = item.work_injury_compensation.json_content.end_date ? new Date(moment(item.work_injury_compensation.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;

                        //Public liability claim insurance
                        item.public_liability_claim_insurance.json_content.policy_premium = JSON.stringify(item.public_liability_claim_insurance.json_content.policy_premium)
                        item.public_liability_claim_insurance.json_content.issue_date = item.public_liability_claim_insurance.json_content.issue_date ? new Date(moment(item.public_liability_claim_insurance.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.start_date = item.public_liability_claim_insurance.json_content.start_date ? new Date(moment(item.public_liability_claim_insurance.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.end_date = item.public_liability_claim_insurance.json_content.end_date ? new Date(moment(item.public_liability_claim_insurance.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;
                    });
                    return;
                }

                temp.forEach((item)  => {
                    item.contract_sum   = (item.contract_sum === 0 || !item.contract_sum) ?  '' : this.$accounting.formatMoney(item.contract_sum);
                    item.start_date     = (item.start_date != null) ? new Date(item.start_date) : null
                    item.end_date       = (item.end_date != null) ? new Date(item.end_date) : null
                    item.sor_adjustment = (item.sor_adjustment != null) ? parseFloat(parseFloat((item.sor_adjustment)*100).toFixed(2)) + "" : null;

                    if (item.extra_info) {
                        if (item.extra_info.loaDate) {
                            item.extra_info.loaDate = (item.extra_info.loaDate != null) ? new Date(item.extra_info.loaDate) : null;
                        }
                        if (item.extra_info.agreementDate) {
                            item.extra_info.agreementDate = (item.extra_info.agreementDate != null) ? new Date(item.extra_info.agreementDate) : null;
                        }
                        if (item.extra_info.clientLetterDate) {
                            item.extra_info.clientLetterDate = (item.extra_info.clientLetterDate != null) ? new Date(item.extra_info.clientLetterDate) : null;
                        }
                    }

                    //type: option, extension_period_main
                    if(type == 'option' || type == 'extension_period_main') {
                        let val = {
                            value: 'up',
                            label: 'Mark Up'
                        };

                        if(item.sor_adjustment < 0) {
                            item.sor_adjustment = item.sor_adjustment.replace("-", "")
                            val.value = 'down';
                            val.label = 'Mark Down';
                        }

                        item.type = val;
                    }
                });
        },
        loadRootNatureFeedBack() {
            this.loading.nature_feedback = true;
            global.axios(`api/contracts/${this.CaseCreateObj.contract.id}/tree-nature-feedback/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    this.treeNatureFeedBack = response.data.data;
                    this.loading.nature_feedback = false;

                }).catch(error => {});
        },
        loadOptionServiceCategory({
            action,
            parentNode,
            callback
        }) {
            simulateAsyncOperation(async () => {
                parentNode.children = await this.getServiceCategory(parentNode.data.id, this.CaseCreateObj.contract.id)
                callback()
            })
        },
        loadOptionNatureFeedBack({
            action,
            parentNode,
            callback
        }) {
            simulateAsyncOperation(async () => {
                parentNode.children = await this.getNatureFeedBack(parentNode.data.id, this.CaseCreateObj.contract.id)
                callback()
            })
        },
        getProperty(property_root_id, contract_id) {
            return new Promise((resolve, reject) => {
                global.axios(`api/contracts/${contract_id}/tree-properties/${property_root_id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        resolve(response.data.data)
                    }).catch(error => {});
            });
        },

        getServiceCategory(service_category_root_id, contract_id) {
            return new Promise((resolve, reject) => {
                global.axios(`api/contracts/${contract_id}/tree-service-categories/${service_category_root_id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        resolve(response.data.data)
                    }).catch(error => {});
            });
        },
        getNatureFeedBack(nature_feedback_root_id, contract_id) {
            return new Promise((resolve, reject) => {
                global.axios(`api/contracts/${contract_id}/tree-nature-feedback/${nature_feedback_root_id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        resolve(response.data.data)
                    }).catch(error => {});
            });
        },
        getContract() {
            let filters = {
                case_setting_module: { type:"text", value:"Generic", function:"ilike", with:[] }
            }
            this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filters, 100, 1])
                .then(response => {
                    this.clientContracts = response.data;

                    this.emailFeature();

                })
        },
        emailFeature()
        {
            if(this.$route.params.email_id != 0 && !!this.$route.params.email_id){
                        let params = Object.assign({
                                    email_id: this.$route.params.email_id
                                });
                        
                        this.$store.dispatch(`EmailIntegrationController/searchContract`, params)
                            .then(response => {


                                if(response.data.data)
                                {
                                    
                                    let contract = this.clientContracts.find(element => element.contract_name == response.data.data.contract_name);

                                    // this.CaseCreateObj.contract = this.clientContracts[0];
                                    this.CaseCreateObj.contract = contract;
                                    // this.changeContract(this.clientContracts[0]);
                                    this.changeContract(contract);
                                    this.CaseCreateObj.recorded_by.email=response.data.data.recorded_email;
                                    this.CaseCreateObj.recorded_by.name=response.data.data.recorded_by;

                                    this.getSalutations();

                                    this.requestor_field= true;
                                    
                                    if(response.data.data.received_time !==null){
                                        this.CaseCreateObj.reported_date = new Date(response.data.data.received_time); 
                                        this.CaseCreateObj.reported_time = moment(new Date(response.data.data.received_time)).format("HH:mm");
                                    }
                                    
                                    if(response.data.data.case_requestor)
                                    {
                                        this.requestor_type=response.data.data.case_requestor.requestor_type;
                                        this.selectRequestors = [response.data.data.case_requestor.addresses];

                                    }else
                                    {
                                        this.CaseCreateObj.isNewRequestor=true;
                                        this.requestor_field=true;
                                        // this.requestor_type="FM Staff";
                                        
                                        // this.CaseCreateObj.requestor.email = 'hein@gmail.com';
                                        // this.CaseCreateObj.requestor.first_name = 'Hein';
                                        // this.CaseCreateObj.requestor.last_name = 'Hein';
                                        // this.CaseCreateObj.requestor.salutation = "Mr";
                                        // this.CaseCreateObj.requestor.primary_phone=19992;
                                        // this.CaseCreateObj.requestor.secondary_phone=19992;
                                        // this.CaseCreateObj.requestor.call_in_phone = null;
                                        // this.CaseCreateObj.requestor.alternative_phone = null;
                                        // this.CaseCreateObj.requestor.requestor_user_id = null;
                                        // this.CaseCreateObj.requestor.requestor_company_id = null;
                                        // this.CaseCreateObj.requestor.preferred_contact_mode = "Email";
                                        // this.CaseCreateObj.requestor.tags = [];
                                        // this.CaseCreateObj.requestor.company_name = null;
                                        
                                        let new_requestor = {email: response.data.data.email,first_name:response.data.data.first_name == null ? "":response.data.data.first_name,last_name:response.data.data.last_name,salutation:'Mr'};
                                        let obj=Object.assign(new_requestor);
                                        // this.selectRequestors = [obj];
                                        this.CaseCreateObj.requestor = obj;
                                        
                                        // let new_requestor = {email: response.data.data.email,first_name:response.data.data.first_name == null ? "":response.data.data.first_name,last_name:response.data.data.last_name,salutation:'Mr'};
                                        // let obj=Object.assign(new_requestor);
                                        
                                        // this.selectRequestors = [obj];

                                        

                                        
                                    }
                                    
                                }
                                
                                
                            });

                            this.modals.customEmailPopup.active = true;
                            this.openModalEmail();
            }
            else{
                this.modals.customEmailPopup.active = false;
            }
        },
        openModalEmail(){
                
                 this.modals.viewemail.loading = true;  

                 let params = Object.assign({
                                    email_id: this.$route.params.email_id
                                });
                        
                this.$store.dispatch("EmailIntegrationController/EachEmail", params)
                .then(response => {
                    
                    this.modals.viewemail.data.to=response.data.data.to;
                    this.modals.viewemail.data.cc=response.data.data.cc;
                    this.modals.viewemail.data.subject=response.data.data.subject;
                    this.modals.viewemail.data.from_name_address=response.data.data.from_name_address;
                    this.modals.viewemail.data.date=response.data.data.date;
                    
                    var doc=this.modals.viewemail.iframeEL.contentWindow.document;
                    doc.open();
                    doc.write(response.data.data.body!=null?response.data.data.body:"");
                    doc.close();
                    this.modals.viewemail.loading = false;  

                    if(response.data.data.attachments.length>0)
                    {
                        this.modals.viewemail.data.files=response.data.data.attachments;    
                    }
                });
                
                
        },
        async previewFile(attachment)
        {
            const link = document.createElement('a');
            var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
            link.href= path;
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
        },
        checkShowImage(val) {
            if (!val) return false;
            let arrTemp = val.split('/');
            if (!arrTemp || arrTemp.length < 2 || arrTemp[0] != 'image') return false;
            return true;
        },
        searchContract(search, loading) {
            this.clientContracts = []
            loading(true);
            if (this.timer.contract) {
                clearTimeout(this.timer.contract);
                this.timer.contract = null;
            }
            this.timer.contract = setTimeout(() => {
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {
                        case_setting_module: { type:"text", value:"Generic", function:"ilike", with:[] },
                        contract_name: { type:"text", value: search, function:"ilike", with:[] }
                    }, 1000, 1])
                    .then(response => {
                        this.clientContracts = response.data
                        loading(false)
                    })
                    .catch(err => {
                        loading(false)
                    })
            }, 500);
        },
        applyProperty() {
            if (this.selectedNode) {
                this.CaseCreateObj.service_location = this.selectedNode;
            }
            this.modals.properties.open = false;
        },
        select(node) {
            this.selectedNode = node.data
            this.modals.properties.root_path = node.data.root_path
        },
        getData() {
            return new Promise((resolve, reject) => {
                global.axios(`api/properties/tree`, {
                        method: "GET",
                        params: {
                            contract_id: (this.CaseCreateObj && this.CaseCreateObj.contract) ? this.CaseCreateObj.contract.id : null,
                            self: 1
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        response.data.data[0].state = {
                            selected: true,
                            expanded: true
                        };
                        this.treeData = response.data.data
                        this.rootId = response.data.data[0].id;
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
            });
        },
        openModalProperty() {
            this.modals.properties.open = true;
        },
        searchProperty(search, loading) {
            loading(true);
            this.loading.properties = true;
            this.propertiesContracts = []
            if (this.timer.property) {
                clearTimeout(this.timer.property);
                this.timer.property = null;
            }
            this.timer.property = setTimeout(() => {
                this.key_search_property = search;
                this.$store.dispatch('PropertyController/getSearchProperties', {
                        keyword: search,
                        property_root_id: this.CaseCreateObj.contract ? this.CaseCreateObj.contract.property_root_id : null,
                        limit: 100,
                        // is_active: true
                    })
                    .then(response => {
                        this.propertiesContracts = response
                        this.loading.properties = false;
                        loading(false);
                    })
                    .catch(err => {
                        loading(false);
                        this.loading.properties = false;
                    })
            }, 500);
        },
        searchRequestor(search, loading) {
            this.selectRequestors = []
            loading(true);
            if (this.timer.requestor) {
                clearTimeout(this.timer.requestor);
                this.timer.requestor = null;
            }
            this.timer.requestor = setTimeout(() => {
                if (!this.CaseCreateObj.contract) {
                    this.selectRequestors = [];
                    loading(false);
                    return;
                }
                let filter = {
                    client_contract_id: this.CaseCreateObj.contract.id,
                    type: this.requestor_type && this.requestor_type.data_type ? this.requestor_type.data_type : null,
                    search: search
                }
                let params = {
                    filter: filter,
                    limit: 1000,
                    isCMS: true
                }
                this.$store.dispatch(`CaseManagementController/getSelectRequestors`, params)
                    .then(response => {
                        this.selectRequestors = response.data.data.items;
                        loading(false);
                    })
            }, 500);
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.equipment = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipment(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async getEquipment(search = "") {
            return;
            this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
            this.pagesEquipment.filter.tag_name.value = search;
            this.pagesEquipment.filter.contract_id.value = null
            if(this.CaseCreateObj.contract){
              this.pagesEquipment.filter.contract_id.value = this.CaseCreateObj.contract.id
            }

            this.pagesEquipment.filter.location_id.value = null
            if(this.CaseCreateObj.case_detail.location && this.CaseCreateObj.case_detail.location.id){
                this.pagesEquipment.filter.location_id.value = this.CaseCreateObj.case_detail.location.id
            }
            else{
                if(this.CaseCreateObj.service_location){
                    this.pagesEquipment.filter.location_id.value = this.CaseCreateObj.service_location.id
                }
            }

            this.pagesEquipment.filter.service_category_id.value = null;
            if(this.CaseCreateObj.case_detail.service_category && this.CaseCreateObj.case_detail.service_category.id) {
                this.pagesEquipment.filter.service_category_id.value = this.CaseCreateObj.case_detail.service_category.id
            }
            this.loading.equipment = true;
            await this.$store.dispatch("EquipmentV2Controller/getEquipments", this.pagesEquipment)
            .then(response => {
                this.equipment = response.data.data.items;
                this.loading.equipment = false;
            })
            .catch(err => {
                this.loading.equipment = false
            })
        },
        // loadCompany(search = null, loading = () => {}) {
        //     loading(true);
        //     this.companies = []
        //     this.loading.company = true
        //     if (this.timer.company) {
        //         clearTimeout(this.timer.company);
        //         this.timer.company = null;
        //     }
        //     this.timer.company = setTimeout(() => {
        //         this.pagesCompanies.filter.name.value = search;
        //         this.$store.dispatch("AllCompanyController/getItems", this.pagesCompanies)
        //             .then(response => {
        //                 this.companies = response.data.data.items;
        //                 this.loading.company = false;
        //                 loading(false);
        //             })
        //             .catch(err => {
        //                 this.loading.company = false
        //                 loading(false);
        //             })
        //     }, 500);
        // },
        loadSLAByServiceCate(is_reset_fault_type = false) {
          let filter = {
            service_category_id: this.CaseCreateObj.case_detail.service_category && this.CaseCreateObj.case_detail.service_category.id ? this.CaseCreateObj.case_detail.service_category.id : null,
            fault_type_id: this.CaseCreateObj.case_detail.fault_type && this.CaseCreateObj.case_detail.fault_type.id ? this.CaseCreateObj.case_detail.fault_type.id : null
          }
          if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module){
            filter = {
              contract_id : -1
            }
          }else{
            if(!this.CaseCreateObj.case_detail.service_category || !this.CaseCreateObj.case_detail.service_category.hasOwnProperty('id')) {
              this.priority = [];
              return;
            }
          }

            this.loading.priority = true
            this.$store.dispatch("v2SlaController/getSlaList", {
                limit: -1,
                page: 1,
                filter: filter,
            }).then(response => {
                this.loading.priority = false;
                this.priority = response.items;
                if(this.priority.length && is_reset_fault_type) {
                    let objTmp = this.priority.filter(item => item.fault_types && item.fault_types.length > 0);
                    if(objTmp.length) {
                        this.CaseCreateObj.case_detail.sla = objTmp[0];
                    } else {
                        if(this.CaseCreateObj.case_detail.fault_type)
                            this.CaseCreateObj.case_detail.sla = this.priority[0];
                    }

                }
            });
        },
        loadFmStaff(search) {
            this.fm_staff_options = []
            if (!this.CaseCreateObj.contract) {
                return;
            }
            this.loading.fm_staff = true
            if (this.timer.fm_staff) {
                clearTimeout(this.timer.fm_staff);
                this.timer.fm_staff = null;
            }
            this.timer.fm_staff = setTimeout(() => {
                this.$store.dispatch("v2UserController/getAccessFmUsers", {
                        contract_id: this.CaseCreateObj.contract.id,
                        property_id: this.CaseCreateObj.service_location ? this.CaseCreateObj.service_location.id : null,
                        section_name: ["Case Management"],
                        module_name: ["Case"],
                        filter: {
                            name: search || null,
                            roles: ["Public Relations Officer", "Marketing Officer"]
                        }
                    })
                    .then(response => {
                        this.fm_staff_options = response.items;
                        if(this.$route.params.id == 0 &&
                            this.UserLogin &&
                            this.fm_staff_options.length > 0 &&
                            this.CaseCreateObj.contract &&
                            this.CaseCreateObj.contract.case_settings &&
                            this.CaseCreateObj.contract.case_settings.prefill_fm_officer_in_charge_case_creator
                        ){
                            let fmStaff = this.fm_staff_options;
                            let email = this.UserLogin.email;
                            let selected = fmStaff.find(function (x) {
                                return (x.user_email == email);
                            });
                            if(selected){
                                this.CaseCreateObj.fm_staff = selected;
                            }
                        }
                        this.loading.fm_staff = false;
                    })
                    .catch(err => {
                        this.loading.fm_staff = false
                    })
            }, 500);
        },
        loadSupplier() {
            this.supplier_options = []
            this.loading.supplier = true
            if (this.timer.supplier) {
                clearTimeout(this.timer.supplier);
                this.timer.supplier = null;
            }
            this.pagesSupplier.filter.contract_id.value = this.CaseCreateObj.contract && this.CaseCreateObj.contract.id;
            this.timer.supplier = setTimeout(() => {
                this.$store.dispatch("AllCompanyController/getItems", this.pagesSupplier)
                    .then(response => {
                        this.supplier_options = response.data.data.items;
                        this.loading.supplier = false;
                    })
                    .catch(err => {
                        this.loading.supplier = false
                    })
            }, 500);
        },
        validateWhenSubmit() {
            if(!this.requestor_type) {
                this.valid = false;
                return this.$alertNotification("Requestor type is required", "danger");
            }
            if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_avenue_of_feedback_mandatory && !this.avenueOfFeedbackModel) {
                this.valid = false;
                return this.$alertNotification("Avenue of feedback is required", "danger");
            }
            
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.Validate = true;
                this.valid = false;
                if(!this.CaseCreateObj.team_in_charge_id && !this.CaseCreateObj.fm_staff){
                    return this.$alertNotification("Either Team of Officer-in-charge must be assigned", "danger");
                }else{
                    return this.$alertNotification("Please enter in all the fields", "danger");
                }
            }

            if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.require_user_to_select_the_last_node_of_service_category && this.CaseCreateObj.case_detail.service_category.isBatch) {
                this.valid = false;
                return this.$alertNotification("You are required to select the last level of Service Category", "danger");
            }
            if(this.CaseCreateObj.contract && 
                this.CaseCreateObj.contract.case_settings && 
                this.CaseCreateObj.contract.case_settings.is_nature_of_feedback_mandatory && 
                this.CaseCreateObj.case_detail.nature_feedback &&
                !this.CaseCreateObj.case_detail.nature_feedback.id
            ){
                this.valid = false;
                return this.$alertNotification("The Nature of Feedback is required.", "danger");
            }
            if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.require_user_to_select_the_last_node_of_nature_of_feedback && this.CaseCreateObj.case_detail.nature_feedback && this.CaseCreateObj.case_detail.nature_feedback.isBatch) {
                this.valid = false;
                return this.$alertNotification("You are required to select the last level of Nature of Feedback", "danger");
            }

            /* required Unit No - NLT - begin - gfx-969 */
            if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module){
                if ( !this.CaseCreateObj.case_detail.unit_no ) {
                    this.valid = false;
                    return this.$alertNotification('Unit No field is a required field', 'danger');
                }
            }
            /* required Unit No - NLT - end */

            /* required ORI - NLT - begin */
            let oriRequired = 1;
            if ( this.CaseCreateObj.custom_fields ) {
                this.CaseCreateObj.custom_fields.map((item, key) => {
                    if ( item.attribute.name == 'ORI' ) {
                        if ( !item.value ) {
                            oriRequired = 0;
                        }
                    }
                });
            }
            if ( oriRequired !== 1 ) {
                this.valid = false;
                return this.$alertNotification('ORI field is a required field', 'danger');
            }
            /* required ORI - NLT - end */

            this.valid = true;
        },
        resetRequestor() {
            this.CaseCreateObj.addresses = null;
            this.CaseCreateObj.requestor.requestor_type = this.requestorTypeOptions[0] && this.requestorTypeOptions[0].data_type ? this.requestorTypeOptions[0].data_type : null;
            this.CaseCreateObj.requestor.company_name = null;
            this.CaseCreateObj.requestor.salutation = "Mr";
            this.CaseCreateObj.requestor.preferred_contact_mode = "Email";
            this.CaseCreateObj.requestor.first_name = null;
            this.CaseCreateObj.requestor.last_name = null;
            this.CaseCreateObj.requestor.secondary_phone = null;
            this.CaseCreateObj.requestor.primary_phone = null;
            this.CaseCreateObj.requestor.email = null;
            this.CaseCreateObj.requestor.call_in_phone = null;
            this.CaseCreateObj.requestor.alternative_phone = null;
            this.CaseCreateObj.requestor.requestor_user_id = null;
            this.CaseCreateObj.requestor.requestor_company_id = null;
            this.CaseCreateObj.requestor.tags = [];
        },
        loadFMTeam() {
            this.fm_group_options = []
            if (!this.CaseCreateObj.contract) {
                return;
            }
            this.$store.dispatch("UserGroupController/getItems", {
                    page: 1,
                    limit: -1,
                    filter: {
                        contract_id: this.CaseCreateObj.contract.id
                    }
                })
                .then(response => {
                    this.fm_group_options = response.items;
                })
                .catch(err => {
                    this.fm_group_options = [];
                })
        },
        checkInTeam() {
            if (this.CaseCreateObj.team_in_charge_id) {
                let checkUserLogin = false;
                if (this.UserLogin.user_team && this.UserLogin.user_team.length) {
                    for (let i = 0; i < this.UserLogin.user_team.length; i++) {
                        if (this.UserLogin.user_team[i].group_id === this.CaseCreateObj.team_in_charge_id) {
                            checkUserLogin = true;
                        }
                    }
                }
                return checkUserLogin;
            } else {
                return false;
            }
        },
        checkHelpDeskRWOReject(){
            if(this.checkRoleOnlyHelpDesk()){
                if(this.Item && this.Item.order && this.Item.order.length > 0){
                    let arrOrder  = Object.assign([], this.Item.order);
                    for (let i = 0; i < arrOrder.length; i++) {
                        if(!arrOrder[i].order_status.includes('Rejected')){
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            }
            return false;
        },
        checkRoleOnlyHelpDesk(){
            if (this.UserLogin && this.UserLogin.roles && this.UserLogin.roles.length > 0) {
                for (let i = 0; i < this.UserLogin.roles.length; i++) {
                    if (this.UserLogin.roles[i].name === 'Help Desk') {
                        return true;
                    }
                }
            }
            return false;
        },
        checkRoleHelpdesk() {
            if (this.UserLogin && this.UserLogin.roles && this.UserLogin.roles.length == 1) {
                if (this.UserLogin.roles[0].name === 'Help Desk') {
                    if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.settings && this.CaseCreateObj.contract.settings.is_allow_help_desk_raise_wo) {
                        return true;
                    }
                    return false;
                }
            }

            return true;
            // if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.settings && this.CaseCreateObj.contract.settings.is_allow_help_desk_raise_wo){
            //     if (this.UserLogin && this.UserLogin.roles && this.UserLogin.roles.length > 0) {
            //         for (let i = 0; i < this.UserLogin.roles.length; i++) {
            //             if (this.UserLogin.roles[i].name === 'Help Desk') {
            //                 return true;
            //             }
            //         }
            //     }
            // }
            // return false;
        },
        getSalutations(){
            let filter = {reference_type: "Salutation"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.salutationOptions = response.items;
                })
        },
        getPreferredMode(){
            let filter = {reference_type: "Preferred Mode of Contact"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.preferModeOfContactOptions = response.items;
                })
        },
        getNatureOfFeedbackOptions(){
            let filter = {reference_type: "Nature Of Feedback Options"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.natureOfFeedbackOptions = response.items;
                })
        },
        getAvenueOfFeedbackOption(){
            let filter = {
                reference_type: { type: "text", value: "Avenue Of Feedback", function: "ilike", with: [] },
                reference_value_abbr: { type: "null", value: "", function: "ilike", with: [] },
            };
            if(this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module){
                filter.reference_value_abbr.type = 'not-null';
            }
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "reference_value_text",
                sortDirection: "asc",
                isCMS:1
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.avenueOfFeedbackOption = response.items;
                })
        },
        getRequestorTypeOptions(){
            if(!this.CaseCreateObj.contract || !this.CaseCreateObj.contract.id) {
                this.requestorTypeOptions = [];
                return;
            }
            let filter = { contract_id: this.CaseCreateObj.contract.id };
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
                isNullLoadMaster: '1'
            };
            this.$store.dispatch(`CaseSettingsController/getListCaseRequestorTypes`, params)
                .then(response => {
                    this.requestorTypeOptions = response.items;
                    if(this.requestorTypeOptions.length) {
                        this.CaseCreateObj.requestor.requestor_type = this.requestorTypeOptions[0].reference_value_text
                    } else {
                        this.CaseCreateObj.requestor.requestor_type = null
                    }
                })
        },

        loadCheckStatusSetting(){
            this.checkStatusSetting = true
            if(this.CaseCreateObj && this.CaseCreateObj.contract && this.CaseCreateObj.contract.settings && this.CaseCreateObj.contract.settings.do_not_allow_raising_rwo_from_case_with_status && this.CaseCreateObj.contract.settings.do_not_allow_raising_rwo_from_case_with_status.length) {
                if(this.CaseCreateObj.contract.settings.do_not_allow_raising_rwo_from_case_with_status.includes(this.CaseCreateObj.status))
                    this.checkStatusSetting = false
                else {
                    if (this.CaseCreateObj.fm_staff && !this.CaseCreateObj.work_order_id && this.CaseCreateObj.supplier) {
                        this.checkStatusSetting = true
                    } else {
                        this.checkStatusSetting = false
                    }
                }

            }
        },
        //
        loadCompany(search = null, loading = () => {}) {
            loading(true);
            this.companies = []
            this.loading.company = true
            if (this.timer.company) {
                clearTimeout(this.timer.company);
                this.timer.company = null;
            }
            this.timer.company = setTimeout(() => {
                this.pagesCompanies.filter.name.value = search;
                this.$store.dispatch("AllCompanyController/getItems", this.pagesCompanies)
                    .then(response => {
                        this.optionsLinkToExistingToCompany = response.data.data.items;
                        this.loading.company = false;
                        loading(false);
                    })
                    .catch(err => {
                        this.loading.company = false
                        loading(false);
                    })
            }, 500);
        },
        loadUsers(search = null, loading = () => {}) {
            loading(true);
            this.companies = []
            if (this.timer.company) {
                clearTimeout(this.timer.company);
                this.timer.company = null;
            }
            this.timer.company = setTimeout(() => {
                this.pagesCompanies.filter.name.value = search;
                this.$store.dispatch("v2UserController/getListUser", this.pagesUsers)
                    .then(response => {
                        this.optionsLinkToExistingToUser = response.items;
                        loading(false);
                    })
                    .catch(err => {
                        loading(false);
                    })
            }, 500);
        },
        loadOptionsLinkToExisting() {
            if(this.requestor_type && this.requestor_type.data_type) {
                switch (this.requestor_type.data_type) {
                     case "Company Profile":
                        this.pagesCompanies.filter.is_client.value   = null;
                        this.pagesCompanies.filter.is_supplier.value = null;
                        this.pagesCompanies.filter.is_fm_company.value = null;
                        this.loadCompany();
                        break;
                    case "Client":
                        this.pagesCompanies.filter.is_client.value = true;
                        this.pagesCompanies.filter.is_supplier.value = null;
                        this.pagesCompanies.filter.is_fm_company.value = null;
                        this.loadCompany();
                        break;
                    case "Supplier":
                        this.pagesCompanies.filter.is_supplier.value = true;
                        this.pagesCompanies.filter.is_fm_company.value = null;
                        this.pagesCompanies.filter.is_client.value = null;
                        this.loadCompany();
                        break;
                    case "FM Company":
                        this.pagesCompanies.filter.is_supplier.value = false;
                        this.pagesCompanies.filter.is_fm_company.value = true;
                        this.pagesCompanies.filter.is_client.value = null;
                        this.loadCompany();
                        break;
                    case "User Account":
                        this.pagesUsers.filter.type_user = "fm-officer";
                        this.loadUsers();
                        break;
                    case "Tenant":
                        this.pagesUsers.filter.type_user = "tenant";
                        this.loadUsers();
                        break;
                    default:
                        this.optionsLinkToExistingToUser = [];
                        this.optionsLinkToExistingToCompany = [];
                }
            }
        },
        populateToTequestor() {
            if(!this.selectedLinkToExisting) {
                return this.$alertNotification("please select link to existing", "danger");
            }

            if(this.requestor_type.data_type == 'Company Profile' || this.requestor_type.data_type == 'Client' || this.requestor_type.data_type == 'Supplier'|| this.requestor_type.data_type == 'FM Company') {
                this.CaseCreateObj.requestor.company_name = this.selectedLinkToExisting.name;
                this.CaseCreateObj.requestor.requestor_company_id = this.selectedLinkToExisting.id;
                if(this.selectedLinkToExisting.mailing_address) {
                    this.CaseCreateObj.requestor.email = this.selectedLinkToExisting.email || null
                    this.CaseCreateObj.requestor.salutation = this.selectedLinkToExisting.salutation || null
                    this.CaseCreateObj.requestor.first_name = this.selectedLinkToExisting.first_name || null
                    this.CaseCreateObj.requestor.last_name  = this.selectedLinkToExisting.last_name || null
                    this.CaseCreateObj.requestor.primary_phone   = this.selectedLinkToExisting.primary_phone || null
                    this.CaseCreateObj.requestor.secondary_phone = this.selectedLinkToExisting.secondary_phone || null
                }
            }

            if(this.requestor_type.data_type == 'User Account' || this.requestor_type.data_type == 'Tenant') {
                this.CaseCreateObj.requestor.company_name = this.selectedLinkToExisting.organization && this.selectedLinkToExisting.organization.name ? this.selectedLinkToExisting.organization.name : null;
                this.CaseCreateObj.requestor.requestor_company_id = this.selectedLinkToExisting.organization && this.selectedLinkToExisting.organization.id ? this.selectedLinkToExisting.organization.id : null;
                this.CaseCreateObj.requestor.email = this.selectedLinkToExisting.email || null
                this.CaseCreateObj.requestor.first_name = this.selectedLinkToExisting.first_name || null
                this.CaseCreateObj.requestor.last_name  = this.selectedLinkToExisting.last_name || null
                this.CaseCreateObj.requestor.requestor_user_id = this.selectedLinkToExisting.requestor_user_id || null
            }
        },
        getTags(type, reference_type) {
            let filter = {reference_type: reference_type, contract_id: this.CaseCreateObj.contract.id};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.optionTags[type] = response.items;
                })
        },
        getCustomFields() {
            this.$store.dispatch('CaseManagementController/getCaseSettingCustomFields', {
                contract_id: this.CaseCreateObj.contract.id,
            }).then(response => {
                this.CaseCreateObj.custom_fields = response.data.data;
            }).catch(err => {
                console.log(err);
            })
        },
        changeContract(val) {
            if(val) {
                this.getCustomFields();
            }
        },
        getCaseSubLocation() {
            this.optionsCaseSubLocation = [];
            if(!this.CaseCreateObj.case_detail.location || !this.CaseCreateObj.case_detail.location.id) return;
            this.$store.dispatch('CaseManagementController/getCaseSubLocation', {
                limit: -1,
                page: 1,
                filter: {
                    property_id: this.CaseCreateObj.case_detail.location.id,
                }
            }).then(response => {
                this.optionsCaseSubLocation = response.data.data.items;
            }).catch(err => {
                console.log(err);
            })
        },
    //    openEscalation(is_open_popup = true){
    //       if(is_open_popup) {
    //          this.modals.escalation.title = 'Escalation to Stakeholder'
    //           this.modals.escalation.open = true
    //           this.modals.escalation.loading_content = true
    //       }
    //      this.$store.dispatch("EscalationController/getItems", {
    //       page:1,
    //       limit:-1,
    //       filter:{
    //         service_category_id:this.CaseCreateObj.case_detail.service_category ? this.CaseCreateObj.case_detail.service_category.id : 0
    //       }
    //     })
    //         .then(response => {
    //           this.modals.escalation.data.to = null
    //           this.modals.escalation.data.cc = null
    //           if(this.modals.nltNextAction.data.status.value !== 'nlt-escalate-to-stakeholder'){
    //             this.modals.escalation.data.subject = null
    //             this.modals.escalation.data.body = null
    //           }
    //           if(response.items){
    //             let checkData = false
    //             for(let i = 0; i < response.items.length; i++){
    //               if(checkData) continue
    //               let item = response.items[i]
    //               if(item.centre_office && (!this.CaseCreateObj.case_detail.fault_type || this.CaseCreateObj.case_detail.fault_type.fault_name !== item.centre_office)){ continue }
    //               if(item.requestor_type && (!this.requestor_type || item.requestor_type !== this.requestor_type.title)){ continue }
    //               if(item.requestor_company && (!this.CaseCreateObj.requestor.company_name || item.requestor_company !== this.CaseCreateObj.requestor.company_name)){ continue }
    //               checkData = true
    //               let to_emails = item.to_team ? item.to_team.users.map((x, index) => {
    //                 return x.email
    //               }) :null
    //               let cc_emails = item.cc_team ? item.cc_team.users.map((x, index) => {
    //                 return x.email
    //               }) : null
    //               this.modals.escalation.data.to = to_emails ? to_emails.join(';') : null
    //               this.modals.escalation.data.cc = cc_emails ? cc_emails.join(';') : null
    //               if(this.modals.nltNextAction.data.status.value !== 'nlt-escalate-to-stakeholder'){
    //                 this.modals.escalation.data.subject = item.notification_template ? item.notification_template.title : null
    //                 this.modals.escalation.data.body = item.notification_template ? item.notification_template.content : null
    //               }
    //             }
    //           }
    //           this.modals.escalation.loading_content = false
    //         })
    //         .catch(err => {
    //           this.modals.escalation.data.to = null
    //           this.modals.escalation.data.cc = null
    //           if(this.modals.nltNextAction.data.status.value !== 'nlt-escalate-to-stakeholder'){
    //             this.modals.escalation.data.subject = null
    //             this.modals.escalation.data.body = null
    //           }
    //           this.modals.escalation.loading_content = false
    //         })
    //      if(this.modals.nltNextAction.data.status.value === 'nlt-escalate-to-stakeholder'){
    //        this.$store.dispatch("NotificationTemplateController/getItems", {
    //          page:1,
    //          limit:1,
    //          filter:{
    //            contract_id:this.CaseCreateObj.contract ? this.CaseCreateObj.contract.id : 0,
    //            "notification_event_trigger.name": 'Escalate to Stakeholder'
    //          },
    //          caseID:this.CaseCreateObj.id
    //        })
    //            .then(response => {
    //              this.modals.escalation.data.subject = null
    //              this.modals.escalation.data.body = null
    //              if(response.data.data.items){
    //                let item = response.data.data.items[0]
    //                this.modals.escalation.data.subject = item.title ? item.title : null
    //                this.modals.escalation.data.body = item ? item.content : null
    //              }
    //            })
    //            .catch(err => {
    //              console.log(err)
    //              this.modals.escalation.data.subject = null
    //              this.modals.escalation.data.body = null
    //            })
    //      }

    //   },
    //   sendMail(){
    //       if(!this.modals.escalation.data.to){
    //         return this.$alertNotification("Please enter required field", "danger");
    //       }
    //       if(this.modals.escalation.loading == true) return;
    //       this.modals.escalation.loading = true
    //       let request = Object.assign({}, this.modals.escalation.data);
    //       request.caseId = this.$route.params.id
    //       if(this.modals.nltNextAction.data.status) request.nlt_case_key_action = this.modals.nltNextAction.data.status.value
    //     this.$store.dispatch("CaseManagementController/escalation", request)
    //         .then(response => {
    //           this.modals.escalation.loading = false
    //           this.modals.escalation.open = false;
    //           if(this.modals.nltNextAction.data.status) this.getCaseEdit();
    //           return this.$alertNotification("Successful mailing");
    //         })
    //         .catch(err => {
    //           this.modals.escalation.loading = false;
    //           this.modals.escalation.open = false;
    //         });
    //   },
        showModalNLTNextAction() {
            this.modals.nltNextAction.data.status = null;
            this.modals.nltNextAction.open = true;

        },
        changeNltStatus() {
            if(!this.modals.nltNextAction.data.status) return this.$alertNotification("Next available actions is required", "danger");

            /* required ORI - NLT - begin */
            /* let oriRequired = 1;
            if(['nlt-reply-to-eu-final-nfcr', 'nlt-reply-to-eu-fcr', 'nlt-close-a-case'].includes(this.modals.nltNextAction.data.status.value)) {
                if ( this.CaseCreateObj.custom_fields ) {
                    this.CaseCreateObj.custom_fields.map((item, key) => {
                        if ( item.attribute.name == 'ORI' ) {
                            if ( !item.value ) {
                                oriRequired = 0;
                            }
                        }
                    });
                }
            }

            if ( oriRequired !== 1 ) {
                return this.$alertNotification('ORI field is a required field', 'danger');
            } */
            /* required ORI - NLT - end */

            this.modals.nltNextAction.open = false;
            this.modals.escalation.open  = true;
            // alert(this.CaseCreateObj.id);

            this.$store.dispatch('EmailIntegrationController/latestEmail', {
                caseId: this.CaseCreateObj.id,

            }).then(response => {
                // this.optionsCaseSubLocation = response.data.data.items;
                this.modals.email=response.data.data.item.email;
                // console.log("here");
                // console.log(this.modals.email);
            }).catch(err => {
                console.log(err);
            })

            // this.modals.escalation.data.cc      = null;
            // this.modals.escalation.data.subject = null;
            // this.modals.escalation.data.body    = null;
            // if(['nlt-reply-to-eu-fcr', 'nlt-reply-to-eu-first-nfcr', 'nlt-reply-to-eu-interim', 'nlt-reply-to-eu-final-nfcr', 'nlt-escalate-to-stakeholder', 'nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(this.modals.nltNextAction.data.status.value)) {
            //     if(['nlt-reply-to-eu-fcr', 'nlt-reply-to-eu-first-nfcr', 'nlt-reply-to-eu-interim', 'nlt-reply-to-eu-final-nfcr'].includes(this.modals.nltNextAction.data.status.value)) {
            //         this.modals.escalation.data.to = this.CaseCreateObj.requestor && this.CaseCreateObj.requestor.email ? this.CaseCreateObj.requestor.email : null
            //     }

            //     if(['nlt-escalate-to-stakeholder','nlt-1st-reminder', 'nlt-2nd-reminder', 'nlt-3rd-reminder', 'nlt-4th-reminder'].includes(this.modals.nltNextAction.data.status.value)) {
            //         this.openEscalation(false);
            //     }


            //     this.modals.nltNextAction.open = false;
            //     this.modals.escalation.title = this.modals.nltNextAction.data.status.label;
            //     this.modals.escalation.open  = true;
            // } else {
            //     if(['nlt-close-a-case'].includes(this.modals.nltNextAction.data.status.value)) {
            //         this.modals.nltNextAction.open = false;
            //         this.modals.closeCase.open = true
            //         return;
            //     }
            //     const request = {
            //         caseId: this.$route.params.id,
            //         nlt_case_key_action: this.modals.nltNextAction.data.status.value
            //     }
            //     this.modals.nltNextAction.loading = true;
            //     this.$store.dispatch("CaseManagementController/ntlChangeAction", request)
            //     .then(response => {
            //         this.modals.nltNextAction.loading = false;
            //         this.modals.nltNextAction.open    = false;
            //         this.$alertNotification(this.$notificationV2('editing', 'case'));
            //         this.getCaseEdit();
            //     })
            //     .catch(err => {
            //         this.modals.nltNextAction.loading = false;
            //     });
            // }
        },
        // closeCase() {
        //     this.modals.closeCase.loading = true;
        //     const request = {
        //         caseId: this.$route.params.id,
        //         nlt_case_key_action: this.modals.nltNextAction.data.status.value
        //     }
        //     this.$store.dispatch("CaseManagementController/ntlChangeAction", request)
        //     .then(response => {
        //         this.modals.closeCase.loading = false;
        //         this.modals.closeCase.open    = false;
        //         this.$alertNotification(this.$notificationV2('editing', 'case'));
        //         this.getCaseEdit();
        //     })
        //     .catch(err => {
        //         this.modals.closeCase.loading = false;
        //     });
        // },
        updateNature(val) {
            if(val && val.data)
                this.CaseCreateObj.case_detail.nature_feedback = val
        },
        updateRequestorCompany(val) {
            this.CaseCreateObj.requestor.company_name = val;
        },
        loadDataWhenNextActionSuccess() {
            this.getCaseEdit();
            this.$refs.pvActivities.triggerReloadData();
        },
        updateServiceCategory(val) {
            this.CaseCreateObj.case_detail.service_category = val
        },
        updateAvenueOfFeedback(val) {
            this.avenueOfFeedbackModel = val
        },
        updateEquipment(val){
            this.CaseCreateObj.case_detail.equipment = val;
        },
        getDateTimeNow(){
            if(this.CaseCreateObj.status === 'Cancelled' || this.isDisableSaveOfNLT) return;
            this.CaseCreateObj.reported_date = new Date(moment().format("YYYY-MM-DD"));
            this.CaseCreateObj.reported_time = moment().format("HH:mm");
        },
        iframeNewLoaded(){
            if(this.modals.viewemail.iframeEL && this.modals.viewemail.iframeEL.contentWindow){
                var iframe=this.modals.viewemail.iframeEL;
                //var modalBody = this.$el.querySelectorAll(`#modal-ViewEmail___BV_modal_body_`)[0];
                setTimeout(() => this.iframeNewLoadedDelay(iframe), 1000);
            }    
        },
        iframeNewLoadedDelay(iframe,modalBody){
            var sHeight = iframe.contentWindow.document.body.scrollHeight;
            var buffer = 0;
            if(sHeight<1000){
                buffer=30;
            }
            else if (sHeight<10000){
                buffer=50;
            }
            else {
                buffer =sHeight/100;
            }
            var finalHeight = sHeight + buffer;  
            if(finalHeight<350){
                finalHeight=350;
            }
            iframe.style.height = finalHeight + 'px';
            //modalBody.scrollTop =0;
        },
        checkShowIcon(val) {
            if(!val) return false;
            let type = val.type || val.image_content_type;
            if(!type) return false;
            let arrTemp = type.split('/');
            if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
            return true;
        },
        loadData(casePrevious){
            this.getContract();
            this.pagesFmStaff.filter.is_supplier.value = false;
            this.pagesFmStaff.filter.is_fm_company.value = true;
            this.pagesCompanies.filter.is_client.value = false;
            this.loadFmStaff();
            this.loadFMTeam();
            this.pagesSupplier.filter.is_supplier.value = true;
            this.pagesSupplier.filter.is_fm_company.value = false;
            this.pagesCompanies.filter.is_client.value = false;
            this.loadSupplier();

            this.timeCurrent = moment().format("YYYY-MM-DD HH:mm");
            this.dateRecorded = moment().format("DD.MM.YYYY");
            this.timeRecorded = moment().format("HH:mm");

            //this.getFaultTypesOptions();

            this.pagesCompanies.filter.is_supplier.value = null;
            this.pagesCompanies.filter.is_fm_company.value = null;
            this.pagesCompanies.filter.is_client.value = true;
            this.loadCompany();


            if (this.$route.params.id != "0") {
                this.requestor_field = true
                this.showNowIcon = false
                this.getCaseEdit();
                if(this.ClientContractID && this.ClientContractID.case_settings && this.ClientContractID.case_settings.is_use_nlt_case_module){
                    this.showNowIcon = true;
                }
            } else {
                this.is_reset = false;
                this.CaseCreateObj.recorded_by = this.UserLogin
                if(this.ClientContractID && this.ClientContractID.case_settings && this.ClientContractID.case_settings.is_use_nlt_case_module){
                    //this.CaseCreateObj.reported_date = null
                    //this.CaseCreateObj.reported_time = '00:00'
                    this.showNowIcon = true;
                }else{
                    this.CaseCreateObj.reported_date = new Date(moment().format("YYYY-MM-DD"));
                    this.CaseCreateObj.reported_time = moment().format("HH:mm");
                    this.showNowIcon = false;
                }
            }
            if (this.$route.params.id == "0") {
                this.CaseCreateObj.contract = (this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) ? this.ClientContractID : null;
            }
            if (this.CaseCreateObj.work_order_id) {
                this.canSaveRwo = false
            }
            // this.getEquipment();
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            if(this.ClientContractID && this.ClientContractID.case_settings && this.ClientContractID.case_settings.is_use_nlt_case_module){
                this.getSalutations();
                this.getPreferredMode();
                this.getNatureOfFeedbackOptions();
                this.getAvenueOfFeedbackOption();
                this.getRequestorTypeOptions();
                //this.checkHelpDeskRWOReject();
                this.loadSLAByServiceCate()
            }
        },
        resetCaseData(){
            let casePrevious = Object.assign({}, this.CaseCreateObj);
            this.CaseCreateObj =  {
                id: null,
                addresses: null,
                case_number: null,
                isNewRequestor: false,
                contract: null,
                service_location: null,
                reported_date: casePrevious && casePrevious.reported_date,
                reported_time: casePrevious && casePrevious.reported_time,
                supplier: null,
                fm_staff: null,
                team_in_charge_id: null,
                avenue_of_feedback: "Call",
                status: 'New',
                attachments: [],
                recorded_by: {
                    name: null,
                    phone: null,
                    email: null
                },
                case_detail: {
                    location: null,
                    service_category: null,
                    // nature_of_feedback: "General Enquiries",
                    nature_feedback:null
                },
                case_requestor:{
                    company_name:null
                },
                requestor: {
                    requestor_type: null,
                    company: null,
                    salutation: "Mr",
                    preferred_contact_mode: "Email",
                    secondary_phone: null,
                    primary_phone: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    call_in_phone: null,
                    alternative_phone: null,
                    tags: [],
                    company_name: null
                },
                order: [],
                tags: [],
                custom_fields: []
            };
            this.fm_staff_options =  [];
            this.fm_group_options = [];
            this.supplier_options = [];
            this.CaseDetail = null;
            this.requestor_type = null;
            this.requestor_field = false;
            //load
            this.loadData(casePrevious);
        },
        changeProperty(val) {
            this.loadFmStaff();
            this.CaseCreateObj.case_detail.location = val;
            this.modals.properties.root_path = (val && val.root_path) ? val.root_path : null;
        },
        loadTab(tab) {
            this.tabActive = tab.key
        },
        /*changePriority(val) {
            if(this.CaseCreateObj && this.CaseCreateObj.contract && this.CaseCreateObj.contract.case_settings && !this.CaseCreateObj.contract.case_settings.is_use_nlt_case_module) return;
            if(!val) return;
            this.modals.warningTagsNLT.open = true;
            this.modals.warningTagsNLT.isComplaint = this.modals.warningTagsNLT.valueYes = this.modals.warningTagsNLT.valueNo = null
        },
        submitComplaint() {
            let priority = this.modals.warningTagsNLT.valueYes || this.modals.warningTagsNLT.valueNo
            if(!priority) {
                return this.$alertNotification("Please select the priority level", "danger");
            }
            let arr = this.priority.filter(item => item.priority.toLowerCase() == priority.toLowerCase());
            if(arr && arr.length) this.CaseCreateObj.case_detail.sla = arr[0];
            if(this.modals.warningTagsNLT.isComplaint == 1) {
                let arrTemp = this.optionTags.caseInfo.filter(item => item.reference_value_text.toLowerCase() == 'complaint');
                this.CaseCreateObj.tags = arrTemp
            }

            if(this.modals.warningTagsNLT.isComplaint == 2 && this.CaseCreateObj.tags && this.CaseCreateObj.tags.length) {
                this.CaseCreateObj.tags = this.CaseCreateObj.tags.filter(item => item.reference_value_text.toLowerCase() != 'complaint');
            }

            this.modals.warningTagsNLT.open = false;
        }*/
        showModalConfirmComplaint() {
            this.validateWhenSubmit();
            if (!this.valid) {
                return
            }

            this.modals.warningTagsNLT.isComplaint = null
            this.modals.warningTagsNLT.open = true;
        },
        submitCase() {
        if (this.timer.submit_case) {
                clearTimeout(this.timer.submit_case);
                this.timer.submit_case = null;
            }
            this.timer.submit_case = setTimeout(() => {
                
                if(this.modals.warningTagsNLT.isComplaint == null) {
                    return this.$alertNotification("Please select whether this is a complaint", "danger");
                }

                if(this.modals.warningTagsNLT.loading) return;
                this.modals.warningTagsNLT.loading = true;

                if(this.modals.warningTagsNLT.isComplaint == 1) {
                    let arrTemp = this.optionTags.caseInfo.filter(item => item.reference_value_text.toLowerCase() == 'complaint');
                    if(arrTemp.length) {
                        if(this.CaseCreateObj.tags != null && this.CaseCreateObj.tags.length) {
                            let arrCheck = this.CaseCreateObj.tags.filter(item => item.reference_value_text.toLowerCase() == 'complaint');
                            if(!arrCheck || !arrCheck.length) this.CaseCreateObj.tags.push(arrTemp[0])
                        } else {
                            this.CaseCreateObj.tags = arrTemp
                        }
                    }
                }

                if(this.modals.warningTagsNLT.isComplaint == 2 && this.CaseCreateObj.tags != null && this.CaseCreateObj.tags.length) {
                    this.CaseCreateObj.tags = this.CaseCreateObj.tags.filter(item => item.reference_value_text.toLowerCase() != 'complaint');
                }

                let priority_text = 'normal';
                if(this.avenueOfFeedbackModel && this.avenueOfFeedbackModel.reference_value_abbr == 'qp-email-urgent') {
                    priority_text = 'urgent';
                }

                let arrPriority = this.priority.filter(item => item.priority.toLowerCase() == priority_text);
                if(arrPriority && arrPriority.length) {
                    this.CaseCreateObj.case_detail.sla = arrPriority[0];
                }
                
                this.modals.warningTagsNLT.open = false;
                this.save(1,false)
            }, 300);
        }
    }
}
</script>
<style lang="scss">
    #modal-Remove {
        .requestor-radio {
            .custom-control {
                &:not(:last-child) {
                    padding-bottom: 10px;
                }
                .custom-control-input:disabled {
                    & ~ .custom-control-label {
                        cursor: no-drop;
                    }
                }
                .custom-control-label {
                    color: #000;
                }
            }
            &.custom-control {
                .custom-control-label {
                    color: #000;
                }
            }
        }
    }
    .text-red {
        color: red;
    }    
</style>
